/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GetAppRouteImport } from './routes/get-app'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AnonRouteImport } from './routes/_anon'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalIndexRouteImport } from './routes/legal.index'
import { Route as WaitingRoomProviderIdRouteImport } from './routes/waiting-room/$providerId'
import { Route as RequestsOptOutRouteImport } from './routes/requests/opt-out'
import { Route as RequestsTokenRouteImport } from './routes/requests/$token'
import { Route as ListingRemoveRouteImport } from './routes/listing/remove'
import { Route as LegalSegmentRouteImport } from './routes/legal.$segment'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthUnlockSecurityCodesRouteImport } from './routes/auth/unlock-security-codes'
import { Route as AuthRemoveSignInMethodRouteImport } from './routes/auth/remove-sign-in-method'
import { Route as AuthErrorRouteImport } from './routes/auth/error'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as Auth2faRevokeRouteImport } from './routes/auth/2fa-revoke'
import { Route as Auth2faChallengeRouteImport } from './routes/auth/2fa-challenge'
import { Route as AnonFindMockRouteImport } from './routes/_anon/find-mock'
import { Route as AnonFindRouteImport } from './routes/_anon/find'
import { Route as DisplayFacilityIdIndexRouteImport } from './routes/display/$facilityId/index'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account/index'
import { Route as WidgetBookProviderIdRouteImport } from './routes/widget/book.$providerId'
import { Route as DisplayFacilityIdCheckinRouteImport } from './routes/display/$facilityId/checkin'
import { Route as AppointmentsConfirmTokenRouteImport } from './routes/appointments/confirm.$token'
import { Route as AuthenticatedVideoTokenRouteImport } from './routes/_authenticated/video/$token'
import { Route as AuthenticatedDashboardSearchesRouteImport } from './routes/_authenticated/dashboard/searches'
import { Route as AuthenticatedDashboardClaimsRouteImport } from './routes/_authenticated/dashboard/claims'
import { Route as AuthenticatedBillingSubscribeRouteImport } from './routes/_authenticated/billing.subscribe'
import { Route as AuthenticatedBillingFoundingRouteImport } from './routes/_authenticated/billing.founding'
import { Route as AuthenticatedAccountUsageRouteImport } from './routes/_authenticated/account/usage'
import { Route as AuthenticatedAccountNotificationsRouteImport } from './routes/_authenticated/account/notifications'
import { Route as AuthenticatedAccountNetworkRouteImport } from './routes/_authenticated/account/network'
import { Route as AuthenticatedAccountBillingRouteImport } from './routes/_authenticated/account/billing'
import { Route as AuthenticatedAccountAddProviderRouteImport } from './routes/_authenticated/account/add-provider'
import { Route as AuthenticatedAccountAddFacilityRouteImport } from './routes/_authenticated/account/add-facility'
import { Route as AuthenticatedAccountAddBusinessRouteImport } from './routes/_authenticated/account/add-business'
import { Route as AnonBookProviderIdRouteImport } from './routes/_anon/book.$providerId'
import { Route as AuthenticatedAccountProviderRouteRouteImport } from './routes/_authenticated/account/provider/route'
import { Route as AuthenticatedAccountUserIndexRouteImport } from './routes/_authenticated/account/user/index'
import { Route as AuthenticatedAccountProviderIndexRouteImport } from './routes/_authenticated/account/provider/index'
import { Route as AuthenticatedAccountUserWalletRouteImport } from './routes/_authenticated/account/user/wallet'
import { Route as AuthenticatedAccountUserWaitlistRouteImport } from './routes/_authenticated/account/user/waitlist'
import { Route as AuthenticatedAccountUserSettingsRouteImport } from './routes/_authenticated/account/user/settings'
import { Route as AuthenticatedAccountUserSavedSearchesRouteImport } from './routes/_authenticated/account/user/saved-searches'
import { Route as AuthenticatedAccountUserPrescriptionsRouteImport } from './routes/_authenticated/account/user/prescriptions'
import { Route as AuthenticatedAccountUserNotificationsRouteImport } from './routes/_authenticated/account/user/notifications'
import { Route as AuthenticatedAccountUserMessagesRouteImport } from './routes/_authenticated/account/user/messages'
import { Route as AuthenticatedAccountUserMedicalVaultRouteImport } from './routes/_authenticated/account/user/medical-vault'
import { Route as AuthenticatedAccountUserJournalRouteImport } from './routes/_authenticated/account/user/journal'
import { Route as AuthenticatedAccountUserHealthVaultRouteImport } from './routes/_authenticated/account/user/health-vault'
import { Route as AuthenticatedAccountUserHealthPassportRouteImport } from './routes/_authenticated/account/user/health-passport'
import { Route as AuthenticatedAccountUserFavoritesRouteImport } from './routes/_authenticated/account/user/favorites'
import { Route as AuthenticatedAccountUserFamilyRouteImport } from './routes/_authenticated/account/user/family'
import { Route as AuthenticatedAccountUserDashboardRouteImport } from './routes/_authenticated/account/user/dashboard'
import { Route as AuthenticatedAccountUserCollectionsRouteImport } from './routes/_authenticated/account/user/collections'
import { Route as AuthenticatedAccountUserBillingRouteImport } from './routes/_authenticated/account/user/billing'
import { Route as AuthenticatedAccountUserAppointmentsRouteImport } from './routes/_authenticated/account/user/appointments'
import { Route as AuthenticatedAccountProviderVerificationRouteImport } from './routes/_authenticated/account/provider/verification'
import { Route as AuthenticatedAccountProviderTeamRouteImport } from './routes/_authenticated/account/provider/team'
import { Route as AuthenticatedAccountProviderSettingsRouteImport } from './routes/_authenticated/account/provider/settings'
import { Route as AuthenticatedAccountProviderReviewsRouteImport } from './routes/_authenticated/account/provider/reviews'
import { Route as AuthenticatedAccountProviderProfileRouteImport } from './routes/_authenticated/account/provider/profile'
import { Route as AuthenticatedAccountProviderPaymentsRouteImport } from './routes/_authenticated/account/provider/payments'
import { Route as AuthenticatedAccountProviderPatientsRouteImport } from './routes/_authenticated/account/provider/patients'
import { Route as AuthenticatedAccountProviderNotificationsRouteImport } from './routes/_authenticated/account/provider/notifications'
import { Route as AuthenticatedAccountProviderDashboardRouteImport } from './routes/_authenticated/account/provider/dashboard'
import { Route as AuthenticatedAccountProviderCalendarRouteImport } from './routes/_authenticated/account/provider/calendar'
import { Route as AuthenticatedAccountProviderBookingWidgetRouteImport } from './routes/_authenticated/account/provider/booking-widget'
import { Route as AuthenticatedAccountProviderBillingRouteImport } from './routes/_authenticated/account/provider/billing'
import { Route as AuthenticatedAccountProviderAppointmentsRouteImport } from './routes/_authenticated/account/provider/appointments'
import { Route as AuthenticatedAccountProviderApiKeysRouteImport } from './routes/_authenticated/account/provider/api-keys'
import { Route as AuthenticatedAccountProviderAffiliationsRouteImport } from './routes/_authenticated/account/provider/affiliations'
import { Route as AuthenticatedAccountAdminNotificationsRouteImport } from './routes/_authenticated/account/admin/notifications'
import { Route as AuthenticatedAccountFacilityFacilityIdIndexRouteImport } from './routes/_authenticated/account/facility/$facilityId/index'
import { Route as AuthenticatedAccountUserSettingsProfileRouteImport } from './routes/_authenticated/account/user/settings/profile'
import { Route as AuthenticatedAccountUserSettingsNotificationsRouteImport } from './routes/_authenticated/account/user/settings/notifications'
import { Route as AuthenticatedAccountUserSettingsMergeRouteImport } from './routes/_authenticated/account/user/settings/merge'
import { Route as AuthenticatedAccountUserSettingsCalendarRouteImport } from './routes/_authenticated/account/user/settings/calendar'
import { Route as AuthenticatedAccountProviderSettingsNotificationsRouteImport } from './routes/_authenticated/account/provider/settings.notifications'
import { Route as AuthenticatedAccountProviderAnalyticsCalendarRouteImport } from './routes/_authenticated/account/provider/analytics/calendar'
import { Route as AuthenticatedAccountInvitationsTokenTokenRouteImport } from './routes/_authenticated/account/invitations/token.$token'
import { Route as AuthenticatedAccountInvitationsTypeIdRouteImport } from './routes/_authenticated/account/invitations/$type.$id'
import { Route as AuthenticatedAccountFacilityFacilityIdStaffRouteImport } from './routes/_authenticated/account/facility/$facilityId/staff'
import { Route as AuthenticatedAccountFacilityFacilityIdRoomsRouteImport } from './routes/_authenticated/account/facility/$facilityId/rooms'
import { Route as AuthenticatedAccountFacilityFacilityIdReviewsRouteImport } from './routes/_authenticated/account/facility/$facilityId/reviews'
import { Route as AuthenticatedAccountFacilityFacilityIdProvidersRouteImport } from './routes/_authenticated/account/facility/$facilityId/providers'
import { Route as AuthenticatedAccountFacilityFacilityIdProfileRouteImport } from './routes/_authenticated/account/facility/$facilityId/profile'
import { Route as AuthenticatedAccountFacilityFacilityIdPatientsRouteImport } from './routes/_authenticated/account/facility/$facilityId/patients'
import { Route as AuthenticatedAccountFacilityFacilityIdNotificationsRouteImport } from './routes/_authenticated/account/facility/$facilityId/notifications'
import { Route as AuthenticatedAccountFacilityFacilityIdInventoryRouteImport } from './routes/_authenticated/account/facility/$facilityId/inventory'
import { Route as AuthenticatedAccountFacilityFacilityIdHrRouteImport } from './routes/_authenticated/account/facility/$facilityId/hr'
import { Route as AuthenticatedAccountFacilityFacilityIdFinancialsRouteImport } from './routes/_authenticated/account/facility/$facilityId/financials'
import { Route as AuthenticatedAccountFacilityFacilityIdFacilitiesRouteImport } from './routes/_authenticated/account/facility/$facilityId/facilities'
import { Route as AuthenticatedAccountFacilityFacilityIdDocumentsRouteImport } from './routes/_authenticated/account/facility/$facilityId/documents'
import { Route as AuthenticatedAccountFacilityFacilityIdDashboardRouteImport } from './routes/_authenticated/account/facility/$facilityId/dashboard'
import { Route as AuthenticatedAccountFacilityFacilityIdCalendarRouteImport } from './routes/_authenticated/account/facility/$facilityId/calendar'
import { Route as AuthenticatedAccountFacilityFacilityIdBillingRouteImport } from './routes/_authenticated/account/facility/$facilityId/billing'
import { Route as AuthenticatedAccountFacilityFacilityIdAppointmentsRouteImport } from './routes/_authenticated/account/facility/$facilityId/appointments'
import { Route as AuthenticatedAccountFacilityFacilityIdAnalyticsRouteImport } from './routes/_authenticated/account/facility/$facilityId/analytics'
import { Route as AuthenticatedAccountBusinessBusinessIdNotificationsRouteImport } from './routes/_authenticated/account/business.$businessId.notifications'
import { Route as AuthenticatedAccountBusinessBusinessIdBillingRouteImport } from './routes/_authenticated/account/business.$businessId.billing'
import { Route as AuthenticatedAccountBookingConfirmationAppointmentIdRouteImport } from './routes/_authenticated/account/booking/confirmation.$appointmentId'
import { Route as AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRouteImport } from './routes/_authenticated/account/facility/$facilityId/settings.notifications'

const GetAppRoute = GetAppRouteImport.update({
  id: '/get-app',
  path: '/get-app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AnonRoute = AnonRouteImport.update({
  id: '/_anon',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalIndexRoute = LegalIndexRouteImport.update({
  id: '/legal/',
  path: '/legal/',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitingRoomProviderIdRoute = WaitingRoomProviderIdRouteImport.update({
  id: '/waiting-room/$providerId',
  path: '/waiting-room/$providerId',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestsOptOutRoute = RequestsOptOutRouteImport.update({
  id: '/requests/opt-out',
  path: '/requests/opt-out',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestsTokenRoute = RequestsTokenRouteImport.update({
  id: '/requests/$token',
  path: '/requests/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ListingRemoveRoute = ListingRemoveRouteImport.update({
  id: '/listing/remove',
  path: '/listing/remove',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalSegmentRoute = LegalSegmentRouteImport.update({
  id: '/legal/$segment',
  path: '/legal/$segment',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUnlockSecurityCodesRoute = AuthUnlockSecurityCodesRouteImport.update({
  id: '/auth/unlock-security-codes',
  path: '/auth/unlock-security-codes',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRemoveSignInMethodRoute = AuthRemoveSignInMethodRouteImport.update({
  id: '/auth/remove-sign-in-method',
  path: '/auth/remove-sign-in-method',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const Auth2faRevokeRoute = Auth2faRevokeRouteImport.update({
  id: '/auth/2fa-revoke',
  path: '/auth/2fa-revoke',
  getParentRoute: () => rootRouteImport,
} as any)
const Auth2faChallengeRoute = Auth2faChallengeRouteImport.update({
  id: '/auth/2fa-challenge',
  path: '/auth/2fa-challenge',
  getParentRoute: () => rootRouteImport,
} as any)
const AnonFindMockRoute = AnonFindMockRouteImport.update({
  id: '/find-mock',
  path: '/find-mock',
  getParentRoute: () => AnonRoute,
} as any)
const AnonFindRoute = AnonFindRouteImport.update({
  id: '/find',
  path: '/find',
  getParentRoute: () => AnonRoute,
} as any)
const DisplayFacilityIdIndexRoute = DisplayFacilityIdIndexRouteImport.update({
  id: '/display/$facilityId/',
  path: '/display/$facilityId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/account/',
    path: '/account/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const WidgetBookProviderIdRoute = WidgetBookProviderIdRouteImport.update({
  id: '/widget/book/$providerId',
  path: '/widget/book/$providerId',
  getParentRoute: () => rootRouteImport,
} as any)
const DisplayFacilityIdCheckinRoute =
  DisplayFacilityIdCheckinRouteImport.update({
    id: '/display/$facilityId/checkin',
    path: '/display/$facilityId/checkin',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppointmentsConfirmTokenRoute =
  AppointmentsConfirmTokenRouteImport.update({
    id: '/appointments/confirm/$token',
    path: '/appointments/confirm/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedVideoTokenRoute = AuthenticatedVideoTokenRouteImport.update({
  id: '/video/$token',
  path: '/video/$token',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardSearchesRoute =
  AuthenticatedDashboardSearchesRouteImport.update({
    id: '/dashboard/searches',
    path: '/dashboard/searches',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardClaimsRoute =
  AuthenticatedDashboardClaimsRouteImport.update({
    id: '/dashboard/claims',
    path: '/dashboard/claims',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingSubscribeRoute =
  AuthenticatedBillingSubscribeRouteImport.update({
    id: '/billing/subscribe',
    path: '/billing/subscribe',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingFoundingRoute =
  AuthenticatedBillingFoundingRouteImport.update({
    id: '/billing/founding',
    path: '/billing/founding',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUsageRoute =
  AuthenticatedAccountUsageRouteImport.update({
    id: '/account/usage',
    path: '/account/usage',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountNotificationsRoute =
  AuthenticatedAccountNotificationsRouteImport.update({
    id: '/account/notifications',
    path: '/account/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountNetworkRoute =
  AuthenticatedAccountNetworkRouteImport.update({
    id: '/account/network',
    path: '/account/network',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountBillingRoute =
  AuthenticatedAccountBillingRouteImport.update({
    id: '/account/billing',
    path: '/account/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountAddProviderRoute =
  AuthenticatedAccountAddProviderRouteImport.update({
    id: '/account/add-provider',
    path: '/account/add-provider',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountAddFacilityRoute =
  AuthenticatedAccountAddFacilityRouteImport.update({
    id: '/account/add-facility',
    path: '/account/add-facility',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountAddBusinessRoute =
  AuthenticatedAccountAddBusinessRouteImport.update({
    id: '/account/add-business',
    path: '/account/add-business',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AnonBookProviderIdRoute = AnonBookProviderIdRouteImport.update({
  id: '/book/$providerId',
  path: '/book/$providerId',
  getParentRoute: () => AnonRoute,
} as any)
const AuthenticatedAccountProviderRouteRoute =
  AuthenticatedAccountProviderRouteRouteImport.update({
    id: '/account/provider',
    path: '/account/provider',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserIndexRoute =
  AuthenticatedAccountUserIndexRouteImport.update({
    id: '/account/user/',
    path: '/account/user/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountProviderIndexRoute =
  AuthenticatedAccountProviderIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountUserWalletRoute =
  AuthenticatedAccountUserWalletRouteImport.update({
    id: '/account/user/wallet',
    path: '/account/user/wallet',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserWaitlistRoute =
  AuthenticatedAccountUserWaitlistRouteImport.update({
    id: '/account/user/waitlist',
    path: '/account/user/waitlist',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserSettingsRoute =
  AuthenticatedAccountUserSettingsRouteImport.update({
    id: '/account/user/settings',
    path: '/account/user/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserSavedSearchesRoute =
  AuthenticatedAccountUserSavedSearchesRouteImport.update({
    id: '/account/user/saved-searches',
    path: '/account/user/saved-searches',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserPrescriptionsRoute =
  AuthenticatedAccountUserPrescriptionsRouteImport.update({
    id: '/account/user/prescriptions',
    path: '/account/user/prescriptions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserNotificationsRoute =
  AuthenticatedAccountUserNotificationsRouteImport.update({
    id: '/account/user/notifications',
    path: '/account/user/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserMessagesRoute =
  AuthenticatedAccountUserMessagesRouteImport.update({
    id: '/account/user/messages',
    path: '/account/user/messages',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserMedicalVaultRoute =
  AuthenticatedAccountUserMedicalVaultRouteImport.update({
    id: '/account/user/medical-vault',
    path: '/account/user/medical-vault',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserJournalRoute =
  AuthenticatedAccountUserJournalRouteImport.update({
    id: '/account/user/journal',
    path: '/account/user/journal',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserHealthVaultRoute =
  AuthenticatedAccountUserHealthVaultRouteImport.update({
    id: '/account/user/health-vault',
    path: '/account/user/health-vault',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserHealthPassportRoute =
  AuthenticatedAccountUserHealthPassportRouteImport.update({
    id: '/account/user/health-passport',
    path: '/account/user/health-passport',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserFavoritesRoute =
  AuthenticatedAccountUserFavoritesRouteImport.update({
    id: '/account/user/favorites',
    path: '/account/user/favorites',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserFamilyRoute =
  AuthenticatedAccountUserFamilyRouteImport.update({
    id: '/account/user/family',
    path: '/account/user/family',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserDashboardRoute =
  AuthenticatedAccountUserDashboardRouteImport.update({
    id: '/account/user/dashboard',
    path: '/account/user/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserCollectionsRoute =
  AuthenticatedAccountUserCollectionsRouteImport.update({
    id: '/account/user/collections',
    path: '/account/user/collections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserBillingRoute =
  AuthenticatedAccountUserBillingRouteImport.update({
    id: '/account/user/billing',
    path: '/account/user/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserAppointmentsRoute =
  AuthenticatedAccountUserAppointmentsRouteImport.update({
    id: '/account/user/appointments',
    path: '/account/user/appointments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountProviderVerificationRoute =
  AuthenticatedAccountProviderVerificationRouteImport.update({
    id: '/verification',
    path: '/verification',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderTeamRoute =
  AuthenticatedAccountProviderTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderSettingsRoute =
  AuthenticatedAccountProviderSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderReviewsRoute =
  AuthenticatedAccountProviderReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderProfileRoute =
  AuthenticatedAccountProviderProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderPaymentsRoute =
  AuthenticatedAccountProviderPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderPatientsRoute =
  AuthenticatedAccountProviderPatientsRouteImport.update({
    id: '/patients',
    path: '/patients',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderNotificationsRoute =
  AuthenticatedAccountProviderNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderDashboardRoute =
  AuthenticatedAccountProviderDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderCalendarRoute =
  AuthenticatedAccountProviderCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderBookingWidgetRoute =
  AuthenticatedAccountProviderBookingWidgetRouteImport.update({
    id: '/booking-widget',
    path: '/booking-widget',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderBillingRoute =
  AuthenticatedAccountProviderBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderAppointmentsRoute =
  AuthenticatedAccountProviderAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderApiKeysRoute =
  AuthenticatedAccountProviderApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountProviderAffiliationsRoute =
  AuthenticatedAccountProviderAffiliationsRouteImport.update({
    id: '/affiliations',
    path: '/affiliations',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountAdminNotificationsRoute =
  AuthenticatedAccountAdminNotificationsRouteImport.update({
    id: '/account/admin/notifications',
    path: '/account/admin/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdIndexRoute =
  AuthenticatedAccountFacilityFacilityIdIndexRouteImport.update({
    id: '/account/facility/$facilityId/',
    path: '/account/facility/$facilityId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUserSettingsProfileRoute =
  AuthenticatedAccountUserSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedAccountUserSettingsRoute,
  } as any)
const AuthenticatedAccountUserSettingsNotificationsRoute =
  AuthenticatedAccountUserSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAccountUserSettingsRoute,
  } as any)
const AuthenticatedAccountUserSettingsMergeRoute =
  AuthenticatedAccountUserSettingsMergeRouteImport.update({
    id: '/merge',
    path: '/merge',
    getParentRoute: () => AuthenticatedAccountUserSettingsRoute,
  } as any)
const AuthenticatedAccountUserSettingsCalendarRoute =
  AuthenticatedAccountUserSettingsCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthenticatedAccountUserSettingsRoute,
  } as any)
const AuthenticatedAccountProviderSettingsNotificationsRoute =
  AuthenticatedAccountProviderSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAccountProviderSettingsRoute,
  } as any)
const AuthenticatedAccountProviderAnalyticsCalendarRoute =
  AuthenticatedAccountProviderAnalyticsCalendarRouteImport.update({
    id: '/analytics/calendar',
    path: '/analytics/calendar',
    getParentRoute: () => AuthenticatedAccountProviderRouteRoute,
  } as any)
const AuthenticatedAccountInvitationsTokenTokenRoute =
  AuthenticatedAccountInvitationsTokenTokenRouteImport.update({
    id: '/account/invitations/token/$token',
    path: '/account/invitations/token/$token',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountInvitationsTypeIdRoute =
  AuthenticatedAccountInvitationsTypeIdRouteImport.update({
    id: '/account/invitations/$type/$id',
    path: '/account/invitations/$type/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdStaffRoute =
  AuthenticatedAccountFacilityFacilityIdStaffRouteImport.update({
    id: '/account/facility/$facilityId/staff',
    path: '/account/facility/$facilityId/staff',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdRoomsRoute =
  AuthenticatedAccountFacilityFacilityIdRoomsRouteImport.update({
    id: '/account/facility/$facilityId/rooms',
    path: '/account/facility/$facilityId/rooms',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdReviewsRoute =
  AuthenticatedAccountFacilityFacilityIdReviewsRouteImport.update({
    id: '/account/facility/$facilityId/reviews',
    path: '/account/facility/$facilityId/reviews',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdProvidersRoute =
  AuthenticatedAccountFacilityFacilityIdProvidersRouteImport.update({
    id: '/account/facility/$facilityId/providers',
    path: '/account/facility/$facilityId/providers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdProfileRoute =
  AuthenticatedAccountFacilityFacilityIdProfileRouteImport.update({
    id: '/account/facility/$facilityId/profile',
    path: '/account/facility/$facilityId/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdPatientsRoute =
  AuthenticatedAccountFacilityFacilityIdPatientsRouteImport.update({
    id: '/account/facility/$facilityId/patients',
    path: '/account/facility/$facilityId/patients',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdNotificationsRoute =
  AuthenticatedAccountFacilityFacilityIdNotificationsRouteImport.update({
    id: '/account/facility/$facilityId/notifications',
    path: '/account/facility/$facilityId/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdInventoryRoute =
  AuthenticatedAccountFacilityFacilityIdInventoryRouteImport.update({
    id: '/account/facility/$facilityId/inventory',
    path: '/account/facility/$facilityId/inventory',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdHrRoute =
  AuthenticatedAccountFacilityFacilityIdHrRouteImport.update({
    id: '/account/facility/$facilityId/hr',
    path: '/account/facility/$facilityId/hr',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdFinancialsRoute =
  AuthenticatedAccountFacilityFacilityIdFinancialsRouteImport.update({
    id: '/account/facility/$facilityId/financials',
    path: '/account/facility/$facilityId/financials',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdFacilitiesRoute =
  AuthenticatedAccountFacilityFacilityIdFacilitiesRouteImport.update({
    id: '/account/facility/$facilityId/facilities',
    path: '/account/facility/$facilityId/facilities',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdDocumentsRoute =
  AuthenticatedAccountFacilityFacilityIdDocumentsRouteImport.update({
    id: '/account/facility/$facilityId/documents',
    path: '/account/facility/$facilityId/documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdDashboardRoute =
  AuthenticatedAccountFacilityFacilityIdDashboardRouteImport.update({
    id: '/account/facility/$facilityId/dashboard',
    path: '/account/facility/$facilityId/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdCalendarRoute =
  AuthenticatedAccountFacilityFacilityIdCalendarRouteImport.update({
    id: '/account/facility/$facilityId/calendar',
    path: '/account/facility/$facilityId/calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdBillingRoute =
  AuthenticatedAccountFacilityFacilityIdBillingRouteImport.update({
    id: '/account/facility/$facilityId/billing',
    path: '/account/facility/$facilityId/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdAppointmentsRoute =
  AuthenticatedAccountFacilityFacilityIdAppointmentsRouteImport.update({
    id: '/account/facility/$facilityId/appointments',
    path: '/account/facility/$facilityId/appointments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdAnalyticsRoute =
  AuthenticatedAccountFacilityFacilityIdAnalyticsRouteImport.update({
    id: '/account/facility/$facilityId/analytics',
    path: '/account/facility/$facilityId/analytics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountBusinessBusinessIdNotificationsRoute =
  AuthenticatedAccountBusinessBusinessIdNotificationsRouteImport.update({
    id: '/account/business/$businessId/notifications',
    path: '/account/business/$businessId/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountBusinessBusinessIdBillingRoute =
  AuthenticatedAccountBusinessBusinessIdBillingRouteImport.update({
    id: '/account/business/$businessId/billing',
    path: '/account/business/$businessId/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountBookingConfirmationAppointmentIdRoute =
  AuthenticatedAccountBookingConfirmationAppointmentIdRouteImport.update({
    id: '/account/booking/confirmation/$appointmentId',
    path: '/account/booking/confirmation/$appointmentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRoute =
  AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRouteImport.update(
    {
      id: '/account/facility/$facilityId/settings/notifications',
      path: '/account/facility/$facilityId/settings/notifications',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/get-app': typeof GetAppRoute
  '/find': typeof AnonFindRoute
  '/find-mock': typeof AnonFindMockRoute
  '/auth/2fa-challenge': typeof Auth2faChallengeRoute
  '/auth/2fa-revoke': typeof Auth2faRevokeRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/remove-sign-in-method': typeof AuthRemoveSignInMethodRoute
  '/auth/unlock-security-codes': typeof AuthUnlockSecurityCodesRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/legal/$segment': typeof LegalSegmentRoute
  '/listing/remove': typeof ListingRemoveRoute
  '/requests/$token': typeof RequestsTokenRoute
  '/requests/opt-out': typeof RequestsOptOutRoute
  '/waiting-room/$providerId': typeof WaitingRoomProviderIdRoute
  '/legal/': typeof LegalIndexRoute
  '/account/provider': typeof AuthenticatedAccountProviderRouteRouteWithChildren
  '/book/$providerId': typeof AnonBookProviderIdRoute
  '/account/add-business': typeof AuthenticatedAccountAddBusinessRoute
  '/account/add-facility': typeof AuthenticatedAccountAddFacilityRoute
  '/account/add-provider': typeof AuthenticatedAccountAddProviderRoute
  '/account/billing': typeof AuthenticatedAccountBillingRoute
  '/account/network': typeof AuthenticatedAccountNetworkRoute
  '/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/account/usage': typeof AuthenticatedAccountUsageRoute
  '/billing/founding': typeof AuthenticatedBillingFoundingRoute
  '/billing/subscribe': typeof AuthenticatedBillingSubscribeRoute
  '/dashboard/claims': typeof AuthenticatedDashboardClaimsRoute
  '/dashboard/searches': typeof AuthenticatedDashboardSearchesRoute
  '/video/$token': typeof AuthenticatedVideoTokenRoute
  '/appointments/confirm/$token': typeof AppointmentsConfirmTokenRoute
  '/display/$facilityId/checkin': typeof DisplayFacilityIdCheckinRoute
  '/widget/book/$providerId': typeof WidgetBookProviderIdRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/display/$facilityId/': typeof DisplayFacilityIdIndexRoute
  '/account/admin/notifications': typeof AuthenticatedAccountAdminNotificationsRoute
  '/account/provider/affiliations': typeof AuthenticatedAccountProviderAffiliationsRoute
  '/account/provider/api-keys': typeof AuthenticatedAccountProviderApiKeysRoute
  '/account/provider/appointments': typeof AuthenticatedAccountProviderAppointmentsRoute
  '/account/provider/billing': typeof AuthenticatedAccountProviderBillingRoute
  '/account/provider/booking-widget': typeof AuthenticatedAccountProviderBookingWidgetRoute
  '/account/provider/calendar': typeof AuthenticatedAccountProviderCalendarRoute
  '/account/provider/dashboard': typeof AuthenticatedAccountProviderDashboardRoute
  '/account/provider/notifications': typeof AuthenticatedAccountProviderNotificationsRoute
  '/account/provider/patients': typeof AuthenticatedAccountProviderPatientsRoute
  '/account/provider/payments': typeof AuthenticatedAccountProviderPaymentsRoute
  '/account/provider/profile': typeof AuthenticatedAccountProviderProfileRoute
  '/account/provider/reviews': typeof AuthenticatedAccountProviderReviewsRoute
  '/account/provider/settings': typeof AuthenticatedAccountProviderSettingsRouteWithChildren
  '/account/provider/team': typeof AuthenticatedAccountProviderTeamRoute
  '/account/provider/verification': typeof AuthenticatedAccountProviderVerificationRoute
  '/account/user/appointments': typeof AuthenticatedAccountUserAppointmentsRoute
  '/account/user/billing': typeof AuthenticatedAccountUserBillingRoute
  '/account/user/collections': typeof AuthenticatedAccountUserCollectionsRoute
  '/account/user/dashboard': typeof AuthenticatedAccountUserDashboardRoute
  '/account/user/family': typeof AuthenticatedAccountUserFamilyRoute
  '/account/user/favorites': typeof AuthenticatedAccountUserFavoritesRoute
  '/account/user/health-passport': typeof AuthenticatedAccountUserHealthPassportRoute
  '/account/user/health-vault': typeof AuthenticatedAccountUserHealthVaultRoute
  '/account/user/journal': typeof AuthenticatedAccountUserJournalRoute
  '/account/user/medical-vault': typeof AuthenticatedAccountUserMedicalVaultRoute
  '/account/user/messages': typeof AuthenticatedAccountUserMessagesRoute
  '/account/user/notifications': typeof AuthenticatedAccountUserNotificationsRoute
  '/account/user/prescriptions': typeof AuthenticatedAccountUserPrescriptionsRoute
  '/account/user/saved-searches': typeof AuthenticatedAccountUserSavedSearchesRoute
  '/account/user/settings': typeof AuthenticatedAccountUserSettingsRouteWithChildren
  '/account/user/waitlist': typeof AuthenticatedAccountUserWaitlistRoute
  '/account/user/wallet': typeof AuthenticatedAccountUserWalletRoute
  '/account/provider/': typeof AuthenticatedAccountProviderIndexRoute
  '/account/user/': typeof AuthenticatedAccountUserIndexRoute
  '/account/booking/confirmation/$appointmentId': typeof AuthenticatedAccountBookingConfirmationAppointmentIdRoute
  '/account/business/$businessId/billing': typeof AuthenticatedAccountBusinessBusinessIdBillingRoute
  '/account/business/$businessId/notifications': typeof AuthenticatedAccountBusinessBusinessIdNotificationsRoute
  '/account/facility/$facilityId/analytics': typeof AuthenticatedAccountFacilityFacilityIdAnalyticsRoute
  '/account/facility/$facilityId/appointments': typeof AuthenticatedAccountFacilityFacilityIdAppointmentsRoute
  '/account/facility/$facilityId/billing': typeof AuthenticatedAccountFacilityFacilityIdBillingRoute
  '/account/facility/$facilityId/calendar': typeof AuthenticatedAccountFacilityFacilityIdCalendarRoute
  '/account/facility/$facilityId/dashboard': typeof AuthenticatedAccountFacilityFacilityIdDashboardRoute
  '/account/facility/$facilityId/documents': typeof AuthenticatedAccountFacilityFacilityIdDocumentsRoute
  '/account/facility/$facilityId/facilities': typeof AuthenticatedAccountFacilityFacilityIdFacilitiesRoute
  '/account/facility/$facilityId/financials': typeof AuthenticatedAccountFacilityFacilityIdFinancialsRoute
  '/account/facility/$facilityId/hr': typeof AuthenticatedAccountFacilityFacilityIdHrRoute
  '/account/facility/$facilityId/inventory': typeof AuthenticatedAccountFacilityFacilityIdInventoryRoute
  '/account/facility/$facilityId/notifications': typeof AuthenticatedAccountFacilityFacilityIdNotificationsRoute
  '/account/facility/$facilityId/patients': typeof AuthenticatedAccountFacilityFacilityIdPatientsRoute
  '/account/facility/$facilityId/profile': typeof AuthenticatedAccountFacilityFacilityIdProfileRoute
  '/account/facility/$facilityId/providers': typeof AuthenticatedAccountFacilityFacilityIdProvidersRoute
  '/account/facility/$facilityId/reviews': typeof AuthenticatedAccountFacilityFacilityIdReviewsRoute
  '/account/facility/$facilityId/rooms': typeof AuthenticatedAccountFacilityFacilityIdRoomsRoute
  '/account/facility/$facilityId/staff': typeof AuthenticatedAccountFacilityFacilityIdStaffRoute
  '/account/invitations/$type/$id': typeof AuthenticatedAccountInvitationsTypeIdRoute
  '/account/invitations/token/$token': typeof AuthenticatedAccountInvitationsTokenTokenRoute
  '/account/provider/analytics/calendar': typeof AuthenticatedAccountProviderAnalyticsCalendarRoute
  '/account/provider/settings/notifications': typeof AuthenticatedAccountProviderSettingsNotificationsRoute
  '/account/user/settings/calendar': typeof AuthenticatedAccountUserSettingsCalendarRoute
  '/account/user/settings/merge': typeof AuthenticatedAccountUserSettingsMergeRoute
  '/account/user/settings/notifications': typeof AuthenticatedAccountUserSettingsNotificationsRoute
  '/account/user/settings/profile': typeof AuthenticatedAccountUserSettingsProfileRoute
  '/account/facility/$facilityId/': typeof AuthenticatedAccountFacilityFacilityIdIndexRoute
  '/account/facility/$facilityId/settings/notifications': typeof AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/get-app': typeof GetAppRoute
  '/find': typeof AnonFindRoute
  '/find-mock': typeof AnonFindMockRoute
  '/auth/2fa-challenge': typeof Auth2faChallengeRoute
  '/auth/2fa-revoke': typeof Auth2faRevokeRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/remove-sign-in-method': typeof AuthRemoveSignInMethodRoute
  '/auth/unlock-security-codes': typeof AuthUnlockSecurityCodesRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/legal/$segment': typeof LegalSegmentRoute
  '/listing/remove': typeof ListingRemoveRoute
  '/requests/$token': typeof RequestsTokenRoute
  '/requests/opt-out': typeof RequestsOptOutRoute
  '/waiting-room/$providerId': typeof WaitingRoomProviderIdRoute
  '/legal': typeof LegalIndexRoute
  '/book/$providerId': typeof AnonBookProviderIdRoute
  '/account/add-business': typeof AuthenticatedAccountAddBusinessRoute
  '/account/add-facility': typeof AuthenticatedAccountAddFacilityRoute
  '/account/add-provider': typeof AuthenticatedAccountAddProviderRoute
  '/account/billing': typeof AuthenticatedAccountBillingRoute
  '/account/network': typeof AuthenticatedAccountNetworkRoute
  '/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/account/usage': typeof AuthenticatedAccountUsageRoute
  '/billing/founding': typeof AuthenticatedBillingFoundingRoute
  '/billing/subscribe': typeof AuthenticatedBillingSubscribeRoute
  '/dashboard/claims': typeof AuthenticatedDashboardClaimsRoute
  '/dashboard/searches': typeof AuthenticatedDashboardSearchesRoute
  '/video/$token': typeof AuthenticatedVideoTokenRoute
  '/appointments/confirm/$token': typeof AppointmentsConfirmTokenRoute
  '/display/$facilityId/checkin': typeof DisplayFacilityIdCheckinRoute
  '/widget/book/$providerId': typeof WidgetBookProviderIdRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/display/$facilityId': typeof DisplayFacilityIdIndexRoute
  '/account/admin/notifications': typeof AuthenticatedAccountAdminNotificationsRoute
  '/account/provider/affiliations': typeof AuthenticatedAccountProviderAffiliationsRoute
  '/account/provider/api-keys': typeof AuthenticatedAccountProviderApiKeysRoute
  '/account/provider/appointments': typeof AuthenticatedAccountProviderAppointmentsRoute
  '/account/provider/billing': typeof AuthenticatedAccountProviderBillingRoute
  '/account/provider/booking-widget': typeof AuthenticatedAccountProviderBookingWidgetRoute
  '/account/provider/calendar': typeof AuthenticatedAccountProviderCalendarRoute
  '/account/provider/dashboard': typeof AuthenticatedAccountProviderDashboardRoute
  '/account/provider/notifications': typeof AuthenticatedAccountProviderNotificationsRoute
  '/account/provider/patients': typeof AuthenticatedAccountProviderPatientsRoute
  '/account/provider/payments': typeof AuthenticatedAccountProviderPaymentsRoute
  '/account/provider/profile': typeof AuthenticatedAccountProviderProfileRoute
  '/account/provider/reviews': typeof AuthenticatedAccountProviderReviewsRoute
  '/account/provider/settings': typeof AuthenticatedAccountProviderSettingsRouteWithChildren
  '/account/provider/team': typeof AuthenticatedAccountProviderTeamRoute
  '/account/provider/verification': typeof AuthenticatedAccountProviderVerificationRoute
  '/account/user/appointments': typeof AuthenticatedAccountUserAppointmentsRoute
  '/account/user/billing': typeof AuthenticatedAccountUserBillingRoute
  '/account/user/collections': typeof AuthenticatedAccountUserCollectionsRoute
  '/account/user/dashboard': typeof AuthenticatedAccountUserDashboardRoute
  '/account/user/family': typeof AuthenticatedAccountUserFamilyRoute
  '/account/user/favorites': typeof AuthenticatedAccountUserFavoritesRoute
  '/account/user/health-passport': typeof AuthenticatedAccountUserHealthPassportRoute
  '/account/user/health-vault': typeof AuthenticatedAccountUserHealthVaultRoute
  '/account/user/journal': typeof AuthenticatedAccountUserJournalRoute
  '/account/user/medical-vault': typeof AuthenticatedAccountUserMedicalVaultRoute
  '/account/user/messages': typeof AuthenticatedAccountUserMessagesRoute
  '/account/user/notifications': typeof AuthenticatedAccountUserNotificationsRoute
  '/account/user/prescriptions': typeof AuthenticatedAccountUserPrescriptionsRoute
  '/account/user/saved-searches': typeof AuthenticatedAccountUserSavedSearchesRoute
  '/account/user/settings': typeof AuthenticatedAccountUserSettingsRouteWithChildren
  '/account/user/waitlist': typeof AuthenticatedAccountUserWaitlistRoute
  '/account/user/wallet': typeof AuthenticatedAccountUserWalletRoute
  '/account/provider': typeof AuthenticatedAccountProviderIndexRoute
  '/account/user': typeof AuthenticatedAccountUserIndexRoute
  '/account/booking/confirmation/$appointmentId': typeof AuthenticatedAccountBookingConfirmationAppointmentIdRoute
  '/account/business/$businessId/billing': typeof AuthenticatedAccountBusinessBusinessIdBillingRoute
  '/account/business/$businessId/notifications': typeof AuthenticatedAccountBusinessBusinessIdNotificationsRoute
  '/account/facility/$facilityId/analytics': typeof AuthenticatedAccountFacilityFacilityIdAnalyticsRoute
  '/account/facility/$facilityId/appointments': typeof AuthenticatedAccountFacilityFacilityIdAppointmentsRoute
  '/account/facility/$facilityId/billing': typeof AuthenticatedAccountFacilityFacilityIdBillingRoute
  '/account/facility/$facilityId/calendar': typeof AuthenticatedAccountFacilityFacilityIdCalendarRoute
  '/account/facility/$facilityId/dashboard': typeof AuthenticatedAccountFacilityFacilityIdDashboardRoute
  '/account/facility/$facilityId/documents': typeof AuthenticatedAccountFacilityFacilityIdDocumentsRoute
  '/account/facility/$facilityId/facilities': typeof AuthenticatedAccountFacilityFacilityIdFacilitiesRoute
  '/account/facility/$facilityId/financials': typeof AuthenticatedAccountFacilityFacilityIdFinancialsRoute
  '/account/facility/$facilityId/hr': typeof AuthenticatedAccountFacilityFacilityIdHrRoute
  '/account/facility/$facilityId/inventory': typeof AuthenticatedAccountFacilityFacilityIdInventoryRoute
  '/account/facility/$facilityId/notifications': typeof AuthenticatedAccountFacilityFacilityIdNotificationsRoute
  '/account/facility/$facilityId/patients': typeof AuthenticatedAccountFacilityFacilityIdPatientsRoute
  '/account/facility/$facilityId/profile': typeof AuthenticatedAccountFacilityFacilityIdProfileRoute
  '/account/facility/$facilityId/providers': typeof AuthenticatedAccountFacilityFacilityIdProvidersRoute
  '/account/facility/$facilityId/reviews': typeof AuthenticatedAccountFacilityFacilityIdReviewsRoute
  '/account/facility/$facilityId/rooms': typeof AuthenticatedAccountFacilityFacilityIdRoomsRoute
  '/account/facility/$facilityId/staff': typeof AuthenticatedAccountFacilityFacilityIdStaffRoute
  '/account/invitations/$type/$id': typeof AuthenticatedAccountInvitationsTypeIdRoute
  '/account/invitations/token/$token': typeof AuthenticatedAccountInvitationsTokenTokenRoute
  '/account/provider/analytics/calendar': typeof AuthenticatedAccountProviderAnalyticsCalendarRoute
  '/account/provider/settings/notifications': typeof AuthenticatedAccountProviderSettingsNotificationsRoute
  '/account/user/settings/calendar': typeof AuthenticatedAccountUserSettingsCalendarRoute
  '/account/user/settings/merge': typeof AuthenticatedAccountUserSettingsMergeRoute
  '/account/user/settings/notifications': typeof AuthenticatedAccountUserSettingsNotificationsRoute
  '/account/user/settings/profile': typeof AuthenticatedAccountUserSettingsProfileRoute
  '/account/facility/$facilityId': typeof AuthenticatedAccountFacilityFacilityIdIndexRoute
  '/account/facility/$facilityId/settings/notifications': typeof AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_anon': typeof AnonRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/get-app': typeof GetAppRoute
  '/_anon/find': typeof AnonFindRoute
  '/_anon/find-mock': typeof AnonFindMockRoute
  '/auth/2fa-challenge': typeof Auth2faChallengeRoute
  '/auth/2fa-revoke': typeof Auth2faRevokeRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/remove-sign-in-method': typeof AuthRemoveSignInMethodRoute
  '/auth/unlock-security-codes': typeof AuthUnlockSecurityCodesRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/legal/$segment': typeof LegalSegmentRoute
  '/listing/remove': typeof ListingRemoveRoute
  '/requests/$token': typeof RequestsTokenRoute
  '/requests/opt-out': typeof RequestsOptOutRoute
  '/waiting-room/$providerId': typeof WaitingRoomProviderIdRoute
  '/legal/': typeof LegalIndexRoute
  '/_authenticated/account/provider': typeof AuthenticatedAccountProviderRouteRouteWithChildren
  '/_anon/book/$providerId': typeof AnonBookProviderIdRoute
  '/_authenticated/account/add-business': typeof AuthenticatedAccountAddBusinessRoute
  '/_authenticated/account/add-facility': typeof AuthenticatedAccountAddFacilityRoute
  '/_authenticated/account/add-provider': typeof AuthenticatedAccountAddProviderRoute
  '/_authenticated/account/billing': typeof AuthenticatedAccountBillingRoute
  '/_authenticated/account/network': typeof AuthenticatedAccountNetworkRoute
  '/_authenticated/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/_authenticated/account/usage': typeof AuthenticatedAccountUsageRoute
  '/_authenticated/billing/founding': typeof AuthenticatedBillingFoundingRoute
  '/_authenticated/billing/subscribe': typeof AuthenticatedBillingSubscribeRoute
  '/_authenticated/dashboard/claims': typeof AuthenticatedDashboardClaimsRoute
  '/_authenticated/dashboard/searches': typeof AuthenticatedDashboardSearchesRoute
  '/_authenticated/video/$token': typeof AuthenticatedVideoTokenRoute
  '/appointments/confirm/$token': typeof AppointmentsConfirmTokenRoute
  '/display/$facilityId/checkin': typeof DisplayFacilityIdCheckinRoute
  '/widget/book/$providerId': typeof WidgetBookProviderIdRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/display/$facilityId/': typeof DisplayFacilityIdIndexRoute
  '/_authenticated/account/admin/notifications': typeof AuthenticatedAccountAdminNotificationsRoute
  '/_authenticated/account/provider/affiliations': typeof AuthenticatedAccountProviderAffiliationsRoute
  '/_authenticated/account/provider/api-keys': typeof AuthenticatedAccountProviderApiKeysRoute
  '/_authenticated/account/provider/appointments': typeof AuthenticatedAccountProviderAppointmentsRoute
  '/_authenticated/account/provider/billing': typeof AuthenticatedAccountProviderBillingRoute
  '/_authenticated/account/provider/booking-widget': typeof AuthenticatedAccountProviderBookingWidgetRoute
  '/_authenticated/account/provider/calendar': typeof AuthenticatedAccountProviderCalendarRoute
  '/_authenticated/account/provider/dashboard': typeof AuthenticatedAccountProviderDashboardRoute
  '/_authenticated/account/provider/notifications': typeof AuthenticatedAccountProviderNotificationsRoute
  '/_authenticated/account/provider/patients': typeof AuthenticatedAccountProviderPatientsRoute
  '/_authenticated/account/provider/payments': typeof AuthenticatedAccountProviderPaymentsRoute
  '/_authenticated/account/provider/profile': typeof AuthenticatedAccountProviderProfileRoute
  '/_authenticated/account/provider/reviews': typeof AuthenticatedAccountProviderReviewsRoute
  '/_authenticated/account/provider/settings': typeof AuthenticatedAccountProviderSettingsRouteWithChildren
  '/_authenticated/account/provider/team': typeof AuthenticatedAccountProviderTeamRoute
  '/_authenticated/account/provider/verification': typeof AuthenticatedAccountProviderVerificationRoute
  '/_authenticated/account/user/appointments': typeof AuthenticatedAccountUserAppointmentsRoute
  '/_authenticated/account/user/billing': typeof AuthenticatedAccountUserBillingRoute
  '/_authenticated/account/user/collections': typeof AuthenticatedAccountUserCollectionsRoute
  '/_authenticated/account/user/dashboard': typeof AuthenticatedAccountUserDashboardRoute
  '/_authenticated/account/user/family': typeof AuthenticatedAccountUserFamilyRoute
  '/_authenticated/account/user/favorites': typeof AuthenticatedAccountUserFavoritesRoute
  '/_authenticated/account/user/health-passport': typeof AuthenticatedAccountUserHealthPassportRoute
  '/_authenticated/account/user/health-vault': typeof AuthenticatedAccountUserHealthVaultRoute
  '/_authenticated/account/user/journal': typeof AuthenticatedAccountUserJournalRoute
  '/_authenticated/account/user/medical-vault': typeof AuthenticatedAccountUserMedicalVaultRoute
  '/_authenticated/account/user/messages': typeof AuthenticatedAccountUserMessagesRoute
  '/_authenticated/account/user/notifications': typeof AuthenticatedAccountUserNotificationsRoute
  '/_authenticated/account/user/prescriptions': typeof AuthenticatedAccountUserPrescriptionsRoute
  '/_authenticated/account/user/saved-searches': typeof AuthenticatedAccountUserSavedSearchesRoute
  '/_authenticated/account/user/settings': typeof AuthenticatedAccountUserSettingsRouteWithChildren
  '/_authenticated/account/user/waitlist': typeof AuthenticatedAccountUserWaitlistRoute
  '/_authenticated/account/user/wallet': typeof AuthenticatedAccountUserWalletRoute
  '/_authenticated/account/provider/': typeof AuthenticatedAccountProviderIndexRoute
  '/_authenticated/account/user/': typeof AuthenticatedAccountUserIndexRoute
  '/_authenticated/account/booking/confirmation/$appointmentId': typeof AuthenticatedAccountBookingConfirmationAppointmentIdRoute
  '/_authenticated/account/business/$businessId/billing': typeof AuthenticatedAccountBusinessBusinessIdBillingRoute
  '/_authenticated/account/business/$businessId/notifications': typeof AuthenticatedAccountBusinessBusinessIdNotificationsRoute
  '/_authenticated/account/facility/$facilityId/analytics': typeof AuthenticatedAccountFacilityFacilityIdAnalyticsRoute
  '/_authenticated/account/facility/$facilityId/appointments': typeof AuthenticatedAccountFacilityFacilityIdAppointmentsRoute
  '/_authenticated/account/facility/$facilityId/billing': typeof AuthenticatedAccountFacilityFacilityIdBillingRoute
  '/_authenticated/account/facility/$facilityId/calendar': typeof AuthenticatedAccountFacilityFacilityIdCalendarRoute
  '/_authenticated/account/facility/$facilityId/dashboard': typeof AuthenticatedAccountFacilityFacilityIdDashboardRoute
  '/_authenticated/account/facility/$facilityId/documents': typeof AuthenticatedAccountFacilityFacilityIdDocumentsRoute
  '/_authenticated/account/facility/$facilityId/facilities': typeof AuthenticatedAccountFacilityFacilityIdFacilitiesRoute
  '/_authenticated/account/facility/$facilityId/financials': typeof AuthenticatedAccountFacilityFacilityIdFinancialsRoute
  '/_authenticated/account/facility/$facilityId/hr': typeof AuthenticatedAccountFacilityFacilityIdHrRoute
  '/_authenticated/account/facility/$facilityId/inventory': typeof AuthenticatedAccountFacilityFacilityIdInventoryRoute
  '/_authenticated/account/facility/$facilityId/notifications': typeof AuthenticatedAccountFacilityFacilityIdNotificationsRoute
  '/_authenticated/account/facility/$facilityId/patients': typeof AuthenticatedAccountFacilityFacilityIdPatientsRoute
  '/_authenticated/account/facility/$facilityId/profile': typeof AuthenticatedAccountFacilityFacilityIdProfileRoute
  '/_authenticated/account/facility/$facilityId/providers': typeof AuthenticatedAccountFacilityFacilityIdProvidersRoute
  '/_authenticated/account/facility/$facilityId/reviews': typeof AuthenticatedAccountFacilityFacilityIdReviewsRoute
  '/_authenticated/account/facility/$facilityId/rooms': typeof AuthenticatedAccountFacilityFacilityIdRoomsRoute
  '/_authenticated/account/facility/$facilityId/staff': typeof AuthenticatedAccountFacilityFacilityIdStaffRoute
  '/_authenticated/account/invitations/$type/$id': typeof AuthenticatedAccountInvitationsTypeIdRoute
  '/_authenticated/account/invitations/token/$token': typeof AuthenticatedAccountInvitationsTokenTokenRoute
  '/_authenticated/account/provider/analytics/calendar': typeof AuthenticatedAccountProviderAnalyticsCalendarRoute
  '/_authenticated/account/provider/settings/notifications': typeof AuthenticatedAccountProviderSettingsNotificationsRoute
  '/_authenticated/account/user/settings/calendar': typeof AuthenticatedAccountUserSettingsCalendarRoute
  '/_authenticated/account/user/settings/merge': typeof AuthenticatedAccountUserSettingsMergeRoute
  '/_authenticated/account/user/settings/notifications': typeof AuthenticatedAccountUserSettingsNotificationsRoute
  '/_authenticated/account/user/settings/profile': typeof AuthenticatedAccountUserSettingsProfileRoute
  '/_authenticated/account/facility/$facilityId/': typeof AuthenticatedAccountFacilityFacilityIdIndexRoute
  '/_authenticated/account/facility/$facilityId/settings/notifications': typeof AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/get-app'
    | '/find'
    | '/find-mock'
    | '/auth/2fa-challenge'
    | '/auth/2fa-revoke'
    | '/auth/callback'
    | '/auth/error'
    | '/auth/remove-sign-in-method'
    | '/auth/unlock-security-codes'
    | '/auth/verify'
    | '/legal/$segment'
    | '/listing/remove'
    | '/requests/$token'
    | '/requests/opt-out'
    | '/waiting-room/$providerId'
    | '/legal/'
    | '/account/provider'
    | '/book/$providerId'
    | '/account/add-business'
    | '/account/add-facility'
    | '/account/add-provider'
    | '/account/billing'
    | '/account/network'
    | '/account/notifications'
    | '/account/usage'
    | '/billing/founding'
    | '/billing/subscribe'
    | '/dashboard/claims'
    | '/dashboard/searches'
    | '/video/$token'
    | '/appointments/confirm/$token'
    | '/display/$facilityId/checkin'
    | '/widget/book/$providerId'
    | '/account/'
    | '/display/$facilityId/'
    | '/account/admin/notifications'
    | '/account/provider/affiliations'
    | '/account/provider/api-keys'
    | '/account/provider/appointments'
    | '/account/provider/billing'
    | '/account/provider/booking-widget'
    | '/account/provider/calendar'
    | '/account/provider/dashboard'
    | '/account/provider/notifications'
    | '/account/provider/patients'
    | '/account/provider/payments'
    | '/account/provider/profile'
    | '/account/provider/reviews'
    | '/account/provider/settings'
    | '/account/provider/team'
    | '/account/provider/verification'
    | '/account/user/appointments'
    | '/account/user/billing'
    | '/account/user/collections'
    | '/account/user/dashboard'
    | '/account/user/family'
    | '/account/user/favorites'
    | '/account/user/health-passport'
    | '/account/user/health-vault'
    | '/account/user/journal'
    | '/account/user/medical-vault'
    | '/account/user/messages'
    | '/account/user/notifications'
    | '/account/user/prescriptions'
    | '/account/user/saved-searches'
    | '/account/user/settings'
    | '/account/user/waitlist'
    | '/account/user/wallet'
    | '/account/provider/'
    | '/account/user/'
    | '/account/booking/confirmation/$appointmentId'
    | '/account/business/$businessId/billing'
    | '/account/business/$businessId/notifications'
    | '/account/facility/$facilityId/analytics'
    | '/account/facility/$facilityId/appointments'
    | '/account/facility/$facilityId/billing'
    | '/account/facility/$facilityId/calendar'
    | '/account/facility/$facilityId/dashboard'
    | '/account/facility/$facilityId/documents'
    | '/account/facility/$facilityId/facilities'
    | '/account/facility/$facilityId/financials'
    | '/account/facility/$facilityId/hr'
    | '/account/facility/$facilityId/inventory'
    | '/account/facility/$facilityId/notifications'
    | '/account/facility/$facilityId/patients'
    | '/account/facility/$facilityId/profile'
    | '/account/facility/$facilityId/providers'
    | '/account/facility/$facilityId/reviews'
    | '/account/facility/$facilityId/rooms'
    | '/account/facility/$facilityId/staff'
    | '/account/invitations/$type/$id'
    | '/account/invitations/token/$token'
    | '/account/provider/analytics/calendar'
    | '/account/provider/settings/notifications'
    | '/account/user/settings/calendar'
    | '/account/user/settings/merge'
    | '/account/user/settings/notifications'
    | '/account/user/settings/profile'
    | '/account/facility/$facilityId/'
    | '/account/facility/$facilityId/settings/notifications'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/get-app'
    | '/find'
    | '/find-mock'
    | '/auth/2fa-challenge'
    | '/auth/2fa-revoke'
    | '/auth/callback'
    | '/auth/error'
    | '/auth/remove-sign-in-method'
    | '/auth/unlock-security-codes'
    | '/auth/verify'
    | '/legal/$segment'
    | '/listing/remove'
    | '/requests/$token'
    | '/requests/opt-out'
    | '/waiting-room/$providerId'
    | '/legal'
    | '/book/$providerId'
    | '/account/add-business'
    | '/account/add-facility'
    | '/account/add-provider'
    | '/account/billing'
    | '/account/network'
    | '/account/notifications'
    | '/account/usage'
    | '/billing/founding'
    | '/billing/subscribe'
    | '/dashboard/claims'
    | '/dashboard/searches'
    | '/video/$token'
    | '/appointments/confirm/$token'
    | '/display/$facilityId/checkin'
    | '/widget/book/$providerId'
    | '/account'
    | '/display/$facilityId'
    | '/account/admin/notifications'
    | '/account/provider/affiliations'
    | '/account/provider/api-keys'
    | '/account/provider/appointments'
    | '/account/provider/billing'
    | '/account/provider/booking-widget'
    | '/account/provider/calendar'
    | '/account/provider/dashboard'
    | '/account/provider/notifications'
    | '/account/provider/patients'
    | '/account/provider/payments'
    | '/account/provider/profile'
    | '/account/provider/reviews'
    | '/account/provider/settings'
    | '/account/provider/team'
    | '/account/provider/verification'
    | '/account/user/appointments'
    | '/account/user/billing'
    | '/account/user/collections'
    | '/account/user/dashboard'
    | '/account/user/family'
    | '/account/user/favorites'
    | '/account/user/health-passport'
    | '/account/user/health-vault'
    | '/account/user/journal'
    | '/account/user/medical-vault'
    | '/account/user/messages'
    | '/account/user/notifications'
    | '/account/user/prescriptions'
    | '/account/user/saved-searches'
    | '/account/user/settings'
    | '/account/user/waitlist'
    | '/account/user/wallet'
    | '/account/provider'
    | '/account/user'
    | '/account/booking/confirmation/$appointmentId'
    | '/account/business/$businessId/billing'
    | '/account/business/$businessId/notifications'
    | '/account/facility/$facilityId/analytics'
    | '/account/facility/$facilityId/appointments'
    | '/account/facility/$facilityId/billing'
    | '/account/facility/$facilityId/calendar'
    | '/account/facility/$facilityId/dashboard'
    | '/account/facility/$facilityId/documents'
    | '/account/facility/$facilityId/facilities'
    | '/account/facility/$facilityId/financials'
    | '/account/facility/$facilityId/hr'
    | '/account/facility/$facilityId/inventory'
    | '/account/facility/$facilityId/notifications'
    | '/account/facility/$facilityId/patients'
    | '/account/facility/$facilityId/profile'
    | '/account/facility/$facilityId/providers'
    | '/account/facility/$facilityId/reviews'
    | '/account/facility/$facilityId/rooms'
    | '/account/facility/$facilityId/staff'
    | '/account/invitations/$type/$id'
    | '/account/invitations/token/$token'
    | '/account/provider/analytics/calendar'
    | '/account/provider/settings/notifications'
    | '/account/user/settings/calendar'
    | '/account/user/settings/merge'
    | '/account/user/settings/notifications'
    | '/account/user/settings/profile'
    | '/account/facility/$facilityId'
    | '/account/facility/$facilityId/settings/notifications'
  id:
    | '__root__'
    | '/'
    | '/_anon'
    | '/_authenticated'
    | '/get-app'
    | '/_anon/find'
    | '/_anon/find-mock'
    | '/auth/2fa-challenge'
    | '/auth/2fa-revoke'
    | '/auth/callback'
    | '/auth/error'
    | '/auth/remove-sign-in-method'
    | '/auth/unlock-security-codes'
    | '/auth/verify'
    | '/legal/$segment'
    | '/listing/remove'
    | '/requests/$token'
    | '/requests/opt-out'
    | '/waiting-room/$providerId'
    | '/legal/'
    | '/_authenticated/account/provider'
    | '/_anon/book/$providerId'
    | '/_authenticated/account/add-business'
    | '/_authenticated/account/add-facility'
    | '/_authenticated/account/add-provider'
    | '/_authenticated/account/billing'
    | '/_authenticated/account/network'
    | '/_authenticated/account/notifications'
    | '/_authenticated/account/usage'
    | '/_authenticated/billing/founding'
    | '/_authenticated/billing/subscribe'
    | '/_authenticated/dashboard/claims'
    | '/_authenticated/dashboard/searches'
    | '/_authenticated/video/$token'
    | '/appointments/confirm/$token'
    | '/display/$facilityId/checkin'
    | '/widget/book/$providerId'
    | '/_authenticated/account/'
    | '/display/$facilityId/'
    | '/_authenticated/account/admin/notifications'
    | '/_authenticated/account/provider/affiliations'
    | '/_authenticated/account/provider/api-keys'
    | '/_authenticated/account/provider/appointments'
    | '/_authenticated/account/provider/billing'
    | '/_authenticated/account/provider/booking-widget'
    | '/_authenticated/account/provider/calendar'
    | '/_authenticated/account/provider/dashboard'
    | '/_authenticated/account/provider/notifications'
    | '/_authenticated/account/provider/patients'
    | '/_authenticated/account/provider/payments'
    | '/_authenticated/account/provider/profile'
    | '/_authenticated/account/provider/reviews'
    | '/_authenticated/account/provider/settings'
    | '/_authenticated/account/provider/team'
    | '/_authenticated/account/provider/verification'
    | '/_authenticated/account/user/appointments'
    | '/_authenticated/account/user/billing'
    | '/_authenticated/account/user/collections'
    | '/_authenticated/account/user/dashboard'
    | '/_authenticated/account/user/family'
    | '/_authenticated/account/user/favorites'
    | '/_authenticated/account/user/health-passport'
    | '/_authenticated/account/user/health-vault'
    | '/_authenticated/account/user/journal'
    | '/_authenticated/account/user/medical-vault'
    | '/_authenticated/account/user/messages'
    | '/_authenticated/account/user/notifications'
    | '/_authenticated/account/user/prescriptions'
    | '/_authenticated/account/user/saved-searches'
    | '/_authenticated/account/user/settings'
    | '/_authenticated/account/user/waitlist'
    | '/_authenticated/account/user/wallet'
    | '/_authenticated/account/provider/'
    | '/_authenticated/account/user/'
    | '/_authenticated/account/booking/confirmation/$appointmentId'
    | '/_authenticated/account/business/$businessId/billing'
    | '/_authenticated/account/business/$businessId/notifications'
    | '/_authenticated/account/facility/$facilityId/analytics'
    | '/_authenticated/account/facility/$facilityId/appointments'
    | '/_authenticated/account/facility/$facilityId/billing'
    | '/_authenticated/account/facility/$facilityId/calendar'
    | '/_authenticated/account/facility/$facilityId/dashboard'
    | '/_authenticated/account/facility/$facilityId/documents'
    | '/_authenticated/account/facility/$facilityId/facilities'
    | '/_authenticated/account/facility/$facilityId/financials'
    | '/_authenticated/account/facility/$facilityId/hr'
    | '/_authenticated/account/facility/$facilityId/inventory'
    | '/_authenticated/account/facility/$facilityId/notifications'
    | '/_authenticated/account/facility/$facilityId/patients'
    | '/_authenticated/account/facility/$facilityId/profile'
    | '/_authenticated/account/facility/$facilityId/providers'
    | '/_authenticated/account/facility/$facilityId/reviews'
    | '/_authenticated/account/facility/$facilityId/rooms'
    | '/_authenticated/account/facility/$facilityId/staff'
    | '/_authenticated/account/invitations/$type/$id'
    | '/_authenticated/account/invitations/token/$token'
    | '/_authenticated/account/provider/analytics/calendar'
    | '/_authenticated/account/provider/settings/notifications'
    | '/_authenticated/account/user/settings/calendar'
    | '/_authenticated/account/user/settings/merge'
    | '/_authenticated/account/user/settings/notifications'
    | '/_authenticated/account/user/settings/profile'
    | '/_authenticated/account/facility/$facilityId/'
    | '/_authenticated/account/facility/$facilityId/settings/notifications'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnonRoute: typeof AnonRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GetAppRoute: typeof GetAppRoute
  Auth2faChallengeRoute: typeof Auth2faChallengeRoute
  Auth2faRevokeRoute: typeof Auth2faRevokeRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthErrorRoute: typeof AuthErrorRoute
  AuthRemoveSignInMethodRoute: typeof AuthRemoveSignInMethodRoute
  AuthUnlockSecurityCodesRoute: typeof AuthUnlockSecurityCodesRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  LegalSegmentRoute: typeof LegalSegmentRoute
  ListingRemoveRoute: typeof ListingRemoveRoute
  RequestsTokenRoute: typeof RequestsTokenRoute
  RequestsOptOutRoute: typeof RequestsOptOutRoute
  WaitingRoomProviderIdRoute: typeof WaitingRoomProviderIdRoute
  LegalIndexRoute: typeof LegalIndexRoute
  AppointmentsConfirmTokenRoute: typeof AppointmentsConfirmTokenRoute
  DisplayFacilityIdCheckinRoute: typeof DisplayFacilityIdCheckinRoute
  WidgetBookProviderIdRoute: typeof WidgetBookProviderIdRoute
  DisplayFacilityIdIndexRoute: typeof DisplayFacilityIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/get-app': {
      id: '/get-app'
      path: '/get-app'
      fullPath: '/get-app'
      preLoaderRoute: typeof GetAppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_anon': {
      id: '/_anon'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AnonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/': {
      id: '/legal/'
      path: '/legal'
      fullPath: '/legal/'
      preLoaderRoute: typeof LegalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waiting-room/$providerId': {
      id: '/waiting-room/$providerId'
      path: '/waiting-room/$providerId'
      fullPath: '/waiting-room/$providerId'
      preLoaderRoute: typeof WaitingRoomProviderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/requests/opt-out': {
      id: '/requests/opt-out'
      path: '/requests/opt-out'
      fullPath: '/requests/opt-out'
      preLoaderRoute: typeof RequestsOptOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/requests/$token': {
      id: '/requests/$token'
      path: '/requests/$token'
      fullPath: '/requests/$token'
      preLoaderRoute: typeof RequestsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listing/remove': {
      id: '/listing/remove'
      path: '/listing/remove'
      fullPath: '/listing/remove'
      preLoaderRoute: typeof ListingRemoveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/$segment': {
      id: '/legal/$segment'
      path: '/legal/$segment'
      fullPath: '/legal/$segment'
      preLoaderRoute: typeof LegalSegmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/unlock-security-codes': {
      id: '/auth/unlock-security-codes'
      path: '/auth/unlock-security-codes'
      fullPath: '/auth/unlock-security-codes'
      preLoaderRoute: typeof AuthUnlockSecurityCodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/remove-sign-in-method': {
      id: '/auth/remove-sign-in-method'
      path: '/auth/remove-sign-in-method'
      fullPath: '/auth/remove-sign-in-method'
      preLoaderRoute: typeof AuthRemoveSignInMethodRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/2fa-revoke': {
      id: '/auth/2fa-revoke'
      path: '/auth/2fa-revoke'
      fullPath: '/auth/2fa-revoke'
      preLoaderRoute: typeof Auth2faRevokeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/2fa-challenge': {
      id: '/auth/2fa-challenge'
      path: '/auth/2fa-challenge'
      fullPath: '/auth/2fa-challenge'
      preLoaderRoute: typeof Auth2faChallengeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_anon/find-mock': {
      id: '/_anon/find-mock'
      path: '/find-mock'
      fullPath: '/find-mock'
      preLoaderRoute: typeof AnonFindMockRouteImport
      parentRoute: typeof AnonRoute
    }
    '/_anon/find': {
      id: '/_anon/find'
      path: '/find'
      fullPath: '/find'
      preLoaderRoute: typeof AnonFindRouteImport
      parentRoute: typeof AnonRoute
    }
    '/display/$facilityId/': {
      id: '/display/$facilityId/'
      path: '/display/$facilityId'
      fullPath: '/display/$facilityId/'
      preLoaderRoute: typeof DisplayFacilityIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/widget/book/$providerId': {
      id: '/widget/book/$providerId'
      path: '/widget/book/$providerId'
      fullPath: '/widget/book/$providerId'
      preLoaderRoute: typeof WidgetBookProviderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/display/$facilityId/checkin': {
      id: '/display/$facilityId/checkin'
      path: '/display/$facilityId/checkin'
      fullPath: '/display/$facilityId/checkin'
      preLoaderRoute: typeof DisplayFacilityIdCheckinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appointments/confirm/$token': {
      id: '/appointments/confirm/$token'
      path: '/appointments/confirm/$token'
      fullPath: '/appointments/confirm/$token'
      preLoaderRoute: typeof AppointmentsConfirmTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/video/$token': {
      id: '/_authenticated/video/$token'
      path: '/video/$token'
      fullPath: '/video/$token'
      preLoaderRoute: typeof AuthenticatedVideoTokenRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/searches': {
      id: '/_authenticated/dashboard/searches'
      path: '/dashboard/searches'
      fullPath: '/dashboard/searches'
      preLoaderRoute: typeof AuthenticatedDashboardSearchesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/claims': {
      id: '/_authenticated/dashboard/claims'
      path: '/dashboard/claims'
      fullPath: '/dashboard/claims'
      preLoaderRoute: typeof AuthenticatedDashboardClaimsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing/subscribe': {
      id: '/_authenticated/billing/subscribe'
      path: '/billing/subscribe'
      fullPath: '/billing/subscribe'
      preLoaderRoute: typeof AuthenticatedBillingSubscribeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing/founding': {
      id: '/_authenticated/billing/founding'
      path: '/billing/founding'
      fullPath: '/billing/founding'
      preLoaderRoute: typeof AuthenticatedBillingFoundingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/usage': {
      id: '/_authenticated/account/usage'
      path: '/account/usage'
      fullPath: '/account/usage'
      preLoaderRoute: typeof AuthenticatedAccountUsageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/notifications': {
      id: '/_authenticated/account/notifications'
      path: '/account/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AuthenticatedAccountNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/network': {
      id: '/_authenticated/account/network'
      path: '/account/network'
      fullPath: '/account/network'
      preLoaderRoute: typeof AuthenticatedAccountNetworkRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/billing': {
      id: '/_authenticated/account/billing'
      path: '/account/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof AuthenticatedAccountBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/add-provider': {
      id: '/_authenticated/account/add-provider'
      path: '/account/add-provider'
      fullPath: '/account/add-provider'
      preLoaderRoute: typeof AuthenticatedAccountAddProviderRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/add-facility': {
      id: '/_authenticated/account/add-facility'
      path: '/account/add-facility'
      fullPath: '/account/add-facility'
      preLoaderRoute: typeof AuthenticatedAccountAddFacilityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/add-business': {
      id: '/_authenticated/account/add-business'
      path: '/account/add-business'
      fullPath: '/account/add-business'
      preLoaderRoute: typeof AuthenticatedAccountAddBusinessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_anon/book/$providerId': {
      id: '/_anon/book/$providerId'
      path: '/book/$providerId'
      fullPath: '/book/$providerId'
      preLoaderRoute: typeof AnonBookProviderIdRouteImport
      parentRoute: typeof AnonRoute
    }
    '/_authenticated/account/provider': {
      id: '/_authenticated/account/provider'
      path: '/account/provider'
      fullPath: '/account/provider'
      preLoaderRoute: typeof AuthenticatedAccountProviderRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/': {
      id: '/_authenticated/account/user/'
      path: '/account/user'
      fullPath: '/account/user/'
      preLoaderRoute: typeof AuthenticatedAccountUserIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/provider/': {
      id: '/_authenticated/account/provider/'
      path: '/'
      fullPath: '/account/provider/'
      preLoaderRoute: typeof AuthenticatedAccountProviderIndexRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/user/wallet': {
      id: '/_authenticated/account/user/wallet'
      path: '/account/user/wallet'
      fullPath: '/account/user/wallet'
      preLoaderRoute: typeof AuthenticatedAccountUserWalletRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/waitlist': {
      id: '/_authenticated/account/user/waitlist'
      path: '/account/user/waitlist'
      fullPath: '/account/user/waitlist'
      preLoaderRoute: typeof AuthenticatedAccountUserWaitlistRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/settings': {
      id: '/_authenticated/account/user/settings'
      path: '/account/user/settings'
      fullPath: '/account/user/settings'
      preLoaderRoute: typeof AuthenticatedAccountUserSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/saved-searches': {
      id: '/_authenticated/account/user/saved-searches'
      path: '/account/user/saved-searches'
      fullPath: '/account/user/saved-searches'
      preLoaderRoute: typeof AuthenticatedAccountUserSavedSearchesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/prescriptions': {
      id: '/_authenticated/account/user/prescriptions'
      path: '/account/user/prescriptions'
      fullPath: '/account/user/prescriptions'
      preLoaderRoute: typeof AuthenticatedAccountUserPrescriptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/notifications': {
      id: '/_authenticated/account/user/notifications'
      path: '/account/user/notifications'
      fullPath: '/account/user/notifications'
      preLoaderRoute: typeof AuthenticatedAccountUserNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/messages': {
      id: '/_authenticated/account/user/messages'
      path: '/account/user/messages'
      fullPath: '/account/user/messages'
      preLoaderRoute: typeof AuthenticatedAccountUserMessagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/medical-vault': {
      id: '/_authenticated/account/user/medical-vault'
      path: '/account/user/medical-vault'
      fullPath: '/account/user/medical-vault'
      preLoaderRoute: typeof AuthenticatedAccountUserMedicalVaultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/journal': {
      id: '/_authenticated/account/user/journal'
      path: '/account/user/journal'
      fullPath: '/account/user/journal'
      preLoaderRoute: typeof AuthenticatedAccountUserJournalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/health-vault': {
      id: '/_authenticated/account/user/health-vault'
      path: '/account/user/health-vault'
      fullPath: '/account/user/health-vault'
      preLoaderRoute: typeof AuthenticatedAccountUserHealthVaultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/health-passport': {
      id: '/_authenticated/account/user/health-passport'
      path: '/account/user/health-passport'
      fullPath: '/account/user/health-passport'
      preLoaderRoute: typeof AuthenticatedAccountUserHealthPassportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/favorites': {
      id: '/_authenticated/account/user/favorites'
      path: '/account/user/favorites'
      fullPath: '/account/user/favorites'
      preLoaderRoute: typeof AuthenticatedAccountUserFavoritesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/family': {
      id: '/_authenticated/account/user/family'
      path: '/account/user/family'
      fullPath: '/account/user/family'
      preLoaderRoute: typeof AuthenticatedAccountUserFamilyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/dashboard': {
      id: '/_authenticated/account/user/dashboard'
      path: '/account/user/dashboard'
      fullPath: '/account/user/dashboard'
      preLoaderRoute: typeof AuthenticatedAccountUserDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/collections': {
      id: '/_authenticated/account/user/collections'
      path: '/account/user/collections'
      fullPath: '/account/user/collections'
      preLoaderRoute: typeof AuthenticatedAccountUserCollectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/billing': {
      id: '/_authenticated/account/user/billing'
      path: '/account/user/billing'
      fullPath: '/account/user/billing'
      preLoaderRoute: typeof AuthenticatedAccountUserBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/appointments': {
      id: '/_authenticated/account/user/appointments'
      path: '/account/user/appointments'
      fullPath: '/account/user/appointments'
      preLoaderRoute: typeof AuthenticatedAccountUserAppointmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/provider/verification': {
      id: '/_authenticated/account/provider/verification'
      path: '/verification'
      fullPath: '/account/provider/verification'
      preLoaderRoute: typeof AuthenticatedAccountProviderVerificationRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/team': {
      id: '/_authenticated/account/provider/team'
      path: '/team'
      fullPath: '/account/provider/team'
      preLoaderRoute: typeof AuthenticatedAccountProviderTeamRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/settings': {
      id: '/_authenticated/account/provider/settings'
      path: '/settings'
      fullPath: '/account/provider/settings'
      preLoaderRoute: typeof AuthenticatedAccountProviderSettingsRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/reviews': {
      id: '/_authenticated/account/provider/reviews'
      path: '/reviews'
      fullPath: '/account/provider/reviews'
      preLoaderRoute: typeof AuthenticatedAccountProviderReviewsRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/profile': {
      id: '/_authenticated/account/provider/profile'
      path: '/profile'
      fullPath: '/account/provider/profile'
      preLoaderRoute: typeof AuthenticatedAccountProviderProfileRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/payments': {
      id: '/_authenticated/account/provider/payments'
      path: '/payments'
      fullPath: '/account/provider/payments'
      preLoaderRoute: typeof AuthenticatedAccountProviderPaymentsRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/patients': {
      id: '/_authenticated/account/provider/patients'
      path: '/patients'
      fullPath: '/account/provider/patients'
      preLoaderRoute: typeof AuthenticatedAccountProviderPatientsRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/notifications': {
      id: '/_authenticated/account/provider/notifications'
      path: '/notifications'
      fullPath: '/account/provider/notifications'
      preLoaderRoute: typeof AuthenticatedAccountProviderNotificationsRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/dashboard': {
      id: '/_authenticated/account/provider/dashboard'
      path: '/dashboard'
      fullPath: '/account/provider/dashboard'
      preLoaderRoute: typeof AuthenticatedAccountProviderDashboardRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/calendar': {
      id: '/_authenticated/account/provider/calendar'
      path: '/calendar'
      fullPath: '/account/provider/calendar'
      preLoaderRoute: typeof AuthenticatedAccountProviderCalendarRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/booking-widget': {
      id: '/_authenticated/account/provider/booking-widget'
      path: '/booking-widget'
      fullPath: '/account/provider/booking-widget'
      preLoaderRoute: typeof AuthenticatedAccountProviderBookingWidgetRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/billing': {
      id: '/_authenticated/account/provider/billing'
      path: '/billing'
      fullPath: '/account/provider/billing'
      preLoaderRoute: typeof AuthenticatedAccountProviderBillingRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/appointments': {
      id: '/_authenticated/account/provider/appointments'
      path: '/appointments'
      fullPath: '/account/provider/appointments'
      preLoaderRoute: typeof AuthenticatedAccountProviderAppointmentsRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/api-keys': {
      id: '/_authenticated/account/provider/api-keys'
      path: '/api-keys'
      fullPath: '/account/provider/api-keys'
      preLoaderRoute: typeof AuthenticatedAccountProviderApiKeysRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/provider/affiliations': {
      id: '/_authenticated/account/provider/affiliations'
      path: '/affiliations'
      fullPath: '/account/provider/affiliations'
      preLoaderRoute: typeof AuthenticatedAccountProviderAffiliationsRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/admin/notifications': {
      id: '/_authenticated/account/admin/notifications'
      path: '/account/admin/notifications'
      fullPath: '/account/admin/notifications'
      preLoaderRoute: typeof AuthenticatedAccountAdminNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/': {
      id: '/_authenticated/account/facility/$facilityId/'
      path: '/account/facility/$facilityId'
      fullPath: '/account/facility/$facilityId/'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/user/settings/profile': {
      id: '/_authenticated/account/user/settings/profile'
      path: '/profile'
      fullPath: '/account/user/settings/profile'
      preLoaderRoute: typeof AuthenticatedAccountUserSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedAccountUserSettingsRoute
    }
    '/_authenticated/account/user/settings/notifications': {
      id: '/_authenticated/account/user/settings/notifications'
      path: '/notifications'
      fullPath: '/account/user/settings/notifications'
      preLoaderRoute: typeof AuthenticatedAccountUserSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedAccountUserSettingsRoute
    }
    '/_authenticated/account/user/settings/merge': {
      id: '/_authenticated/account/user/settings/merge'
      path: '/merge'
      fullPath: '/account/user/settings/merge'
      preLoaderRoute: typeof AuthenticatedAccountUserSettingsMergeRouteImport
      parentRoute: typeof AuthenticatedAccountUserSettingsRoute
    }
    '/_authenticated/account/user/settings/calendar': {
      id: '/_authenticated/account/user/settings/calendar'
      path: '/calendar'
      fullPath: '/account/user/settings/calendar'
      preLoaderRoute: typeof AuthenticatedAccountUserSettingsCalendarRouteImport
      parentRoute: typeof AuthenticatedAccountUserSettingsRoute
    }
    '/_authenticated/account/provider/settings/notifications': {
      id: '/_authenticated/account/provider/settings/notifications'
      path: '/notifications'
      fullPath: '/account/provider/settings/notifications'
      preLoaderRoute: typeof AuthenticatedAccountProviderSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedAccountProviderSettingsRoute
    }
    '/_authenticated/account/provider/analytics/calendar': {
      id: '/_authenticated/account/provider/analytics/calendar'
      path: '/analytics/calendar'
      fullPath: '/account/provider/analytics/calendar'
      preLoaderRoute: typeof AuthenticatedAccountProviderAnalyticsCalendarRouteImport
      parentRoute: typeof AuthenticatedAccountProviderRouteRoute
    }
    '/_authenticated/account/invitations/token/$token': {
      id: '/_authenticated/account/invitations/token/$token'
      path: '/account/invitations/token/$token'
      fullPath: '/account/invitations/token/$token'
      preLoaderRoute: typeof AuthenticatedAccountInvitationsTokenTokenRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/invitations/$type/$id': {
      id: '/_authenticated/account/invitations/$type/$id'
      path: '/account/invitations/$type/$id'
      fullPath: '/account/invitations/$type/$id'
      preLoaderRoute: typeof AuthenticatedAccountInvitationsTypeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/staff': {
      id: '/_authenticated/account/facility/$facilityId/staff'
      path: '/account/facility/$facilityId/staff'
      fullPath: '/account/facility/$facilityId/staff'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdStaffRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/rooms': {
      id: '/_authenticated/account/facility/$facilityId/rooms'
      path: '/account/facility/$facilityId/rooms'
      fullPath: '/account/facility/$facilityId/rooms'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdRoomsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/reviews': {
      id: '/_authenticated/account/facility/$facilityId/reviews'
      path: '/account/facility/$facilityId/reviews'
      fullPath: '/account/facility/$facilityId/reviews'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdReviewsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/providers': {
      id: '/_authenticated/account/facility/$facilityId/providers'
      path: '/account/facility/$facilityId/providers'
      fullPath: '/account/facility/$facilityId/providers'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdProvidersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/profile': {
      id: '/_authenticated/account/facility/$facilityId/profile'
      path: '/account/facility/$facilityId/profile'
      fullPath: '/account/facility/$facilityId/profile'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/patients': {
      id: '/_authenticated/account/facility/$facilityId/patients'
      path: '/account/facility/$facilityId/patients'
      fullPath: '/account/facility/$facilityId/patients'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdPatientsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/notifications': {
      id: '/_authenticated/account/facility/$facilityId/notifications'
      path: '/account/facility/$facilityId/notifications'
      fullPath: '/account/facility/$facilityId/notifications'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/inventory': {
      id: '/_authenticated/account/facility/$facilityId/inventory'
      path: '/account/facility/$facilityId/inventory'
      fullPath: '/account/facility/$facilityId/inventory'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdInventoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/hr': {
      id: '/_authenticated/account/facility/$facilityId/hr'
      path: '/account/facility/$facilityId/hr'
      fullPath: '/account/facility/$facilityId/hr'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdHrRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/financials': {
      id: '/_authenticated/account/facility/$facilityId/financials'
      path: '/account/facility/$facilityId/financials'
      fullPath: '/account/facility/$facilityId/financials'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdFinancialsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/facilities': {
      id: '/_authenticated/account/facility/$facilityId/facilities'
      path: '/account/facility/$facilityId/facilities'
      fullPath: '/account/facility/$facilityId/facilities'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdFacilitiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/documents': {
      id: '/_authenticated/account/facility/$facilityId/documents'
      path: '/account/facility/$facilityId/documents'
      fullPath: '/account/facility/$facilityId/documents'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/dashboard': {
      id: '/_authenticated/account/facility/$facilityId/dashboard'
      path: '/account/facility/$facilityId/dashboard'
      fullPath: '/account/facility/$facilityId/dashboard'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/calendar': {
      id: '/_authenticated/account/facility/$facilityId/calendar'
      path: '/account/facility/$facilityId/calendar'
      fullPath: '/account/facility/$facilityId/calendar'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/billing': {
      id: '/_authenticated/account/facility/$facilityId/billing'
      path: '/account/facility/$facilityId/billing'
      fullPath: '/account/facility/$facilityId/billing'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/appointments': {
      id: '/_authenticated/account/facility/$facilityId/appointments'
      path: '/account/facility/$facilityId/appointments'
      fullPath: '/account/facility/$facilityId/appointments'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdAppointmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/analytics': {
      id: '/_authenticated/account/facility/$facilityId/analytics'
      path: '/account/facility/$facilityId/analytics'
      fullPath: '/account/facility/$facilityId/analytics'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/business/$businessId/notifications': {
      id: '/_authenticated/account/business/$businessId/notifications'
      path: '/account/business/$businessId/notifications'
      fullPath: '/account/business/$businessId/notifications'
      preLoaderRoute: typeof AuthenticatedAccountBusinessBusinessIdNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/business/$businessId/billing': {
      id: '/_authenticated/account/business/$businessId/billing'
      path: '/account/business/$businessId/billing'
      fullPath: '/account/business/$businessId/billing'
      preLoaderRoute: typeof AuthenticatedAccountBusinessBusinessIdBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/booking/confirmation/$appointmentId': {
      id: '/_authenticated/account/booking/confirmation/$appointmentId'
      path: '/account/booking/confirmation/$appointmentId'
      fullPath: '/account/booking/confirmation/$appointmentId'
      preLoaderRoute: typeof AuthenticatedAccountBookingConfirmationAppointmentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account/facility/$facilityId/settings/notifications': {
      id: '/_authenticated/account/facility/$facilityId/settings/notifications'
      path: '/account/facility/$facilityId/settings/notifications'
      fullPath: '/account/facility/$facilityId/settings/notifications'
      preLoaderRoute: typeof AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AnonRouteChildren {
  AnonFindRoute: typeof AnonFindRoute
  AnonFindMockRoute: typeof AnonFindMockRoute
  AnonBookProviderIdRoute: typeof AnonBookProviderIdRoute
}

const AnonRouteChildren: AnonRouteChildren = {
  AnonFindRoute: AnonFindRoute,
  AnonFindMockRoute: AnonFindMockRoute,
  AnonBookProviderIdRoute: AnonBookProviderIdRoute,
}

const AnonRouteWithChildren = AnonRoute._addFileChildren(AnonRouteChildren)

interface AuthenticatedAccountProviderSettingsRouteChildren {
  AuthenticatedAccountProviderSettingsNotificationsRoute: typeof AuthenticatedAccountProviderSettingsNotificationsRoute
}

const AuthenticatedAccountProviderSettingsRouteChildren: AuthenticatedAccountProviderSettingsRouteChildren =
  {
    AuthenticatedAccountProviderSettingsNotificationsRoute:
      AuthenticatedAccountProviderSettingsNotificationsRoute,
  }

const AuthenticatedAccountProviderSettingsRouteWithChildren =
  AuthenticatedAccountProviderSettingsRoute._addFileChildren(
    AuthenticatedAccountProviderSettingsRouteChildren,
  )

interface AuthenticatedAccountProviderRouteRouteChildren {
  AuthenticatedAccountProviderAffiliationsRoute: typeof AuthenticatedAccountProviderAffiliationsRoute
  AuthenticatedAccountProviderApiKeysRoute: typeof AuthenticatedAccountProviderApiKeysRoute
  AuthenticatedAccountProviderAppointmentsRoute: typeof AuthenticatedAccountProviderAppointmentsRoute
  AuthenticatedAccountProviderBillingRoute: typeof AuthenticatedAccountProviderBillingRoute
  AuthenticatedAccountProviderBookingWidgetRoute: typeof AuthenticatedAccountProviderBookingWidgetRoute
  AuthenticatedAccountProviderCalendarRoute: typeof AuthenticatedAccountProviderCalendarRoute
  AuthenticatedAccountProviderDashboardRoute: typeof AuthenticatedAccountProviderDashboardRoute
  AuthenticatedAccountProviderNotificationsRoute: typeof AuthenticatedAccountProviderNotificationsRoute
  AuthenticatedAccountProviderPatientsRoute: typeof AuthenticatedAccountProviderPatientsRoute
  AuthenticatedAccountProviderPaymentsRoute: typeof AuthenticatedAccountProviderPaymentsRoute
  AuthenticatedAccountProviderProfileRoute: typeof AuthenticatedAccountProviderProfileRoute
  AuthenticatedAccountProviderReviewsRoute: typeof AuthenticatedAccountProviderReviewsRoute
  AuthenticatedAccountProviderSettingsRoute: typeof AuthenticatedAccountProviderSettingsRouteWithChildren
  AuthenticatedAccountProviderTeamRoute: typeof AuthenticatedAccountProviderTeamRoute
  AuthenticatedAccountProviderVerificationRoute: typeof AuthenticatedAccountProviderVerificationRoute
  AuthenticatedAccountProviderIndexRoute: typeof AuthenticatedAccountProviderIndexRoute
  AuthenticatedAccountProviderAnalyticsCalendarRoute: typeof AuthenticatedAccountProviderAnalyticsCalendarRoute
}

const AuthenticatedAccountProviderRouteRouteChildren: AuthenticatedAccountProviderRouteRouteChildren =
  {
    AuthenticatedAccountProviderAffiliationsRoute:
      AuthenticatedAccountProviderAffiliationsRoute,
    AuthenticatedAccountProviderApiKeysRoute:
      AuthenticatedAccountProviderApiKeysRoute,
    AuthenticatedAccountProviderAppointmentsRoute:
      AuthenticatedAccountProviderAppointmentsRoute,
    AuthenticatedAccountProviderBillingRoute:
      AuthenticatedAccountProviderBillingRoute,
    AuthenticatedAccountProviderBookingWidgetRoute:
      AuthenticatedAccountProviderBookingWidgetRoute,
    AuthenticatedAccountProviderCalendarRoute:
      AuthenticatedAccountProviderCalendarRoute,
    AuthenticatedAccountProviderDashboardRoute:
      AuthenticatedAccountProviderDashboardRoute,
    AuthenticatedAccountProviderNotificationsRoute:
      AuthenticatedAccountProviderNotificationsRoute,
    AuthenticatedAccountProviderPatientsRoute:
      AuthenticatedAccountProviderPatientsRoute,
    AuthenticatedAccountProviderPaymentsRoute:
      AuthenticatedAccountProviderPaymentsRoute,
    AuthenticatedAccountProviderProfileRoute:
      AuthenticatedAccountProviderProfileRoute,
    AuthenticatedAccountProviderReviewsRoute:
      AuthenticatedAccountProviderReviewsRoute,
    AuthenticatedAccountProviderSettingsRoute:
      AuthenticatedAccountProviderSettingsRouteWithChildren,
    AuthenticatedAccountProviderTeamRoute:
      AuthenticatedAccountProviderTeamRoute,
    AuthenticatedAccountProviderVerificationRoute:
      AuthenticatedAccountProviderVerificationRoute,
    AuthenticatedAccountProviderIndexRoute:
      AuthenticatedAccountProviderIndexRoute,
    AuthenticatedAccountProviderAnalyticsCalendarRoute:
      AuthenticatedAccountProviderAnalyticsCalendarRoute,
  }

const AuthenticatedAccountProviderRouteRouteWithChildren =
  AuthenticatedAccountProviderRouteRoute._addFileChildren(
    AuthenticatedAccountProviderRouteRouteChildren,
  )

interface AuthenticatedAccountUserSettingsRouteChildren {
  AuthenticatedAccountUserSettingsCalendarRoute: typeof AuthenticatedAccountUserSettingsCalendarRoute
  AuthenticatedAccountUserSettingsMergeRoute: typeof AuthenticatedAccountUserSettingsMergeRoute
  AuthenticatedAccountUserSettingsNotificationsRoute: typeof AuthenticatedAccountUserSettingsNotificationsRoute
  AuthenticatedAccountUserSettingsProfileRoute: typeof AuthenticatedAccountUserSettingsProfileRoute
}

const AuthenticatedAccountUserSettingsRouteChildren: AuthenticatedAccountUserSettingsRouteChildren =
  {
    AuthenticatedAccountUserSettingsCalendarRoute:
      AuthenticatedAccountUserSettingsCalendarRoute,
    AuthenticatedAccountUserSettingsMergeRoute:
      AuthenticatedAccountUserSettingsMergeRoute,
    AuthenticatedAccountUserSettingsNotificationsRoute:
      AuthenticatedAccountUserSettingsNotificationsRoute,
    AuthenticatedAccountUserSettingsProfileRoute:
      AuthenticatedAccountUserSettingsProfileRoute,
  }

const AuthenticatedAccountUserSettingsRouteWithChildren =
  AuthenticatedAccountUserSettingsRoute._addFileChildren(
    AuthenticatedAccountUserSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAccountProviderRouteRoute: typeof AuthenticatedAccountProviderRouteRouteWithChildren
  AuthenticatedAccountAddBusinessRoute: typeof AuthenticatedAccountAddBusinessRoute
  AuthenticatedAccountAddFacilityRoute: typeof AuthenticatedAccountAddFacilityRoute
  AuthenticatedAccountAddProviderRoute: typeof AuthenticatedAccountAddProviderRoute
  AuthenticatedAccountBillingRoute: typeof AuthenticatedAccountBillingRoute
  AuthenticatedAccountNetworkRoute: typeof AuthenticatedAccountNetworkRoute
  AuthenticatedAccountNotificationsRoute: typeof AuthenticatedAccountNotificationsRoute
  AuthenticatedAccountUsageRoute: typeof AuthenticatedAccountUsageRoute
  AuthenticatedBillingFoundingRoute: typeof AuthenticatedBillingFoundingRoute
  AuthenticatedBillingSubscribeRoute: typeof AuthenticatedBillingSubscribeRoute
  AuthenticatedDashboardClaimsRoute: typeof AuthenticatedDashboardClaimsRoute
  AuthenticatedDashboardSearchesRoute: typeof AuthenticatedDashboardSearchesRoute
  AuthenticatedVideoTokenRoute: typeof AuthenticatedVideoTokenRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
  AuthenticatedAccountAdminNotificationsRoute: typeof AuthenticatedAccountAdminNotificationsRoute
  AuthenticatedAccountUserAppointmentsRoute: typeof AuthenticatedAccountUserAppointmentsRoute
  AuthenticatedAccountUserBillingRoute: typeof AuthenticatedAccountUserBillingRoute
  AuthenticatedAccountUserCollectionsRoute: typeof AuthenticatedAccountUserCollectionsRoute
  AuthenticatedAccountUserDashboardRoute: typeof AuthenticatedAccountUserDashboardRoute
  AuthenticatedAccountUserFamilyRoute: typeof AuthenticatedAccountUserFamilyRoute
  AuthenticatedAccountUserFavoritesRoute: typeof AuthenticatedAccountUserFavoritesRoute
  AuthenticatedAccountUserHealthPassportRoute: typeof AuthenticatedAccountUserHealthPassportRoute
  AuthenticatedAccountUserHealthVaultRoute: typeof AuthenticatedAccountUserHealthVaultRoute
  AuthenticatedAccountUserJournalRoute: typeof AuthenticatedAccountUserJournalRoute
  AuthenticatedAccountUserMedicalVaultRoute: typeof AuthenticatedAccountUserMedicalVaultRoute
  AuthenticatedAccountUserMessagesRoute: typeof AuthenticatedAccountUserMessagesRoute
  AuthenticatedAccountUserNotificationsRoute: typeof AuthenticatedAccountUserNotificationsRoute
  AuthenticatedAccountUserPrescriptionsRoute: typeof AuthenticatedAccountUserPrescriptionsRoute
  AuthenticatedAccountUserSavedSearchesRoute: typeof AuthenticatedAccountUserSavedSearchesRoute
  AuthenticatedAccountUserSettingsRoute: typeof AuthenticatedAccountUserSettingsRouteWithChildren
  AuthenticatedAccountUserWaitlistRoute: typeof AuthenticatedAccountUserWaitlistRoute
  AuthenticatedAccountUserWalletRoute: typeof AuthenticatedAccountUserWalletRoute
  AuthenticatedAccountUserIndexRoute: typeof AuthenticatedAccountUserIndexRoute
  AuthenticatedAccountBookingConfirmationAppointmentIdRoute: typeof AuthenticatedAccountBookingConfirmationAppointmentIdRoute
  AuthenticatedAccountBusinessBusinessIdBillingRoute: typeof AuthenticatedAccountBusinessBusinessIdBillingRoute
  AuthenticatedAccountBusinessBusinessIdNotificationsRoute: typeof AuthenticatedAccountBusinessBusinessIdNotificationsRoute
  AuthenticatedAccountFacilityFacilityIdAnalyticsRoute: typeof AuthenticatedAccountFacilityFacilityIdAnalyticsRoute
  AuthenticatedAccountFacilityFacilityIdAppointmentsRoute: typeof AuthenticatedAccountFacilityFacilityIdAppointmentsRoute
  AuthenticatedAccountFacilityFacilityIdBillingRoute: typeof AuthenticatedAccountFacilityFacilityIdBillingRoute
  AuthenticatedAccountFacilityFacilityIdCalendarRoute: typeof AuthenticatedAccountFacilityFacilityIdCalendarRoute
  AuthenticatedAccountFacilityFacilityIdDashboardRoute: typeof AuthenticatedAccountFacilityFacilityIdDashboardRoute
  AuthenticatedAccountFacilityFacilityIdDocumentsRoute: typeof AuthenticatedAccountFacilityFacilityIdDocumentsRoute
  AuthenticatedAccountFacilityFacilityIdFacilitiesRoute: typeof AuthenticatedAccountFacilityFacilityIdFacilitiesRoute
  AuthenticatedAccountFacilityFacilityIdFinancialsRoute: typeof AuthenticatedAccountFacilityFacilityIdFinancialsRoute
  AuthenticatedAccountFacilityFacilityIdHrRoute: typeof AuthenticatedAccountFacilityFacilityIdHrRoute
  AuthenticatedAccountFacilityFacilityIdInventoryRoute: typeof AuthenticatedAccountFacilityFacilityIdInventoryRoute
  AuthenticatedAccountFacilityFacilityIdNotificationsRoute: typeof AuthenticatedAccountFacilityFacilityIdNotificationsRoute
  AuthenticatedAccountFacilityFacilityIdPatientsRoute: typeof AuthenticatedAccountFacilityFacilityIdPatientsRoute
  AuthenticatedAccountFacilityFacilityIdProfileRoute: typeof AuthenticatedAccountFacilityFacilityIdProfileRoute
  AuthenticatedAccountFacilityFacilityIdProvidersRoute: typeof AuthenticatedAccountFacilityFacilityIdProvidersRoute
  AuthenticatedAccountFacilityFacilityIdReviewsRoute: typeof AuthenticatedAccountFacilityFacilityIdReviewsRoute
  AuthenticatedAccountFacilityFacilityIdRoomsRoute: typeof AuthenticatedAccountFacilityFacilityIdRoomsRoute
  AuthenticatedAccountFacilityFacilityIdStaffRoute: typeof AuthenticatedAccountFacilityFacilityIdStaffRoute
  AuthenticatedAccountInvitationsTypeIdRoute: typeof AuthenticatedAccountInvitationsTypeIdRoute
  AuthenticatedAccountInvitationsTokenTokenRoute: typeof AuthenticatedAccountInvitationsTokenTokenRoute
  AuthenticatedAccountFacilityFacilityIdIndexRoute: typeof AuthenticatedAccountFacilityFacilityIdIndexRoute
  AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRoute: typeof AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountProviderRouteRoute:
    AuthenticatedAccountProviderRouteRouteWithChildren,
  AuthenticatedAccountAddBusinessRoute: AuthenticatedAccountAddBusinessRoute,
  AuthenticatedAccountAddFacilityRoute: AuthenticatedAccountAddFacilityRoute,
  AuthenticatedAccountAddProviderRoute: AuthenticatedAccountAddProviderRoute,
  AuthenticatedAccountBillingRoute: AuthenticatedAccountBillingRoute,
  AuthenticatedAccountNetworkRoute: AuthenticatedAccountNetworkRoute,
  AuthenticatedAccountNotificationsRoute:
    AuthenticatedAccountNotificationsRoute,
  AuthenticatedAccountUsageRoute: AuthenticatedAccountUsageRoute,
  AuthenticatedBillingFoundingRoute: AuthenticatedBillingFoundingRoute,
  AuthenticatedBillingSubscribeRoute: AuthenticatedBillingSubscribeRoute,
  AuthenticatedDashboardClaimsRoute: AuthenticatedDashboardClaimsRoute,
  AuthenticatedDashboardSearchesRoute: AuthenticatedDashboardSearchesRoute,
  AuthenticatedVideoTokenRoute: AuthenticatedVideoTokenRoute,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
  AuthenticatedAccountAdminNotificationsRoute:
    AuthenticatedAccountAdminNotificationsRoute,
  AuthenticatedAccountUserAppointmentsRoute:
    AuthenticatedAccountUserAppointmentsRoute,
  AuthenticatedAccountUserBillingRoute: AuthenticatedAccountUserBillingRoute,
  AuthenticatedAccountUserCollectionsRoute:
    AuthenticatedAccountUserCollectionsRoute,
  AuthenticatedAccountUserDashboardRoute:
    AuthenticatedAccountUserDashboardRoute,
  AuthenticatedAccountUserFamilyRoute: AuthenticatedAccountUserFamilyRoute,
  AuthenticatedAccountUserFavoritesRoute:
    AuthenticatedAccountUserFavoritesRoute,
  AuthenticatedAccountUserHealthPassportRoute:
    AuthenticatedAccountUserHealthPassportRoute,
  AuthenticatedAccountUserHealthVaultRoute:
    AuthenticatedAccountUserHealthVaultRoute,
  AuthenticatedAccountUserJournalRoute: AuthenticatedAccountUserJournalRoute,
  AuthenticatedAccountUserMedicalVaultRoute:
    AuthenticatedAccountUserMedicalVaultRoute,
  AuthenticatedAccountUserMessagesRoute: AuthenticatedAccountUserMessagesRoute,
  AuthenticatedAccountUserNotificationsRoute:
    AuthenticatedAccountUserNotificationsRoute,
  AuthenticatedAccountUserPrescriptionsRoute:
    AuthenticatedAccountUserPrescriptionsRoute,
  AuthenticatedAccountUserSavedSearchesRoute:
    AuthenticatedAccountUserSavedSearchesRoute,
  AuthenticatedAccountUserSettingsRoute:
    AuthenticatedAccountUserSettingsRouteWithChildren,
  AuthenticatedAccountUserWaitlistRoute: AuthenticatedAccountUserWaitlistRoute,
  AuthenticatedAccountUserWalletRoute: AuthenticatedAccountUserWalletRoute,
  AuthenticatedAccountUserIndexRoute: AuthenticatedAccountUserIndexRoute,
  AuthenticatedAccountBookingConfirmationAppointmentIdRoute:
    AuthenticatedAccountBookingConfirmationAppointmentIdRoute,
  AuthenticatedAccountBusinessBusinessIdBillingRoute:
    AuthenticatedAccountBusinessBusinessIdBillingRoute,
  AuthenticatedAccountBusinessBusinessIdNotificationsRoute:
    AuthenticatedAccountBusinessBusinessIdNotificationsRoute,
  AuthenticatedAccountFacilityFacilityIdAnalyticsRoute:
    AuthenticatedAccountFacilityFacilityIdAnalyticsRoute,
  AuthenticatedAccountFacilityFacilityIdAppointmentsRoute:
    AuthenticatedAccountFacilityFacilityIdAppointmentsRoute,
  AuthenticatedAccountFacilityFacilityIdBillingRoute:
    AuthenticatedAccountFacilityFacilityIdBillingRoute,
  AuthenticatedAccountFacilityFacilityIdCalendarRoute:
    AuthenticatedAccountFacilityFacilityIdCalendarRoute,
  AuthenticatedAccountFacilityFacilityIdDashboardRoute:
    AuthenticatedAccountFacilityFacilityIdDashboardRoute,
  AuthenticatedAccountFacilityFacilityIdDocumentsRoute:
    AuthenticatedAccountFacilityFacilityIdDocumentsRoute,
  AuthenticatedAccountFacilityFacilityIdFacilitiesRoute:
    AuthenticatedAccountFacilityFacilityIdFacilitiesRoute,
  AuthenticatedAccountFacilityFacilityIdFinancialsRoute:
    AuthenticatedAccountFacilityFacilityIdFinancialsRoute,
  AuthenticatedAccountFacilityFacilityIdHrRoute:
    AuthenticatedAccountFacilityFacilityIdHrRoute,
  AuthenticatedAccountFacilityFacilityIdInventoryRoute:
    AuthenticatedAccountFacilityFacilityIdInventoryRoute,
  AuthenticatedAccountFacilityFacilityIdNotificationsRoute:
    AuthenticatedAccountFacilityFacilityIdNotificationsRoute,
  AuthenticatedAccountFacilityFacilityIdPatientsRoute:
    AuthenticatedAccountFacilityFacilityIdPatientsRoute,
  AuthenticatedAccountFacilityFacilityIdProfileRoute:
    AuthenticatedAccountFacilityFacilityIdProfileRoute,
  AuthenticatedAccountFacilityFacilityIdProvidersRoute:
    AuthenticatedAccountFacilityFacilityIdProvidersRoute,
  AuthenticatedAccountFacilityFacilityIdReviewsRoute:
    AuthenticatedAccountFacilityFacilityIdReviewsRoute,
  AuthenticatedAccountFacilityFacilityIdRoomsRoute:
    AuthenticatedAccountFacilityFacilityIdRoomsRoute,
  AuthenticatedAccountFacilityFacilityIdStaffRoute:
    AuthenticatedAccountFacilityFacilityIdStaffRoute,
  AuthenticatedAccountInvitationsTypeIdRoute:
    AuthenticatedAccountInvitationsTypeIdRoute,
  AuthenticatedAccountInvitationsTokenTokenRoute:
    AuthenticatedAccountInvitationsTokenTokenRoute,
  AuthenticatedAccountFacilityFacilityIdIndexRoute:
    AuthenticatedAccountFacilityFacilityIdIndexRoute,
  AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRoute:
    AuthenticatedAccountFacilityFacilityIdSettingsNotificationsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnonRoute: AnonRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GetAppRoute: GetAppRoute,
  Auth2faChallengeRoute: Auth2faChallengeRoute,
  Auth2faRevokeRoute: Auth2faRevokeRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthErrorRoute: AuthErrorRoute,
  AuthRemoveSignInMethodRoute: AuthRemoveSignInMethodRoute,
  AuthUnlockSecurityCodesRoute: AuthUnlockSecurityCodesRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  LegalSegmentRoute: LegalSegmentRoute,
  ListingRemoveRoute: ListingRemoveRoute,
  RequestsTokenRoute: RequestsTokenRoute,
  RequestsOptOutRoute: RequestsOptOutRoute,
  WaitingRoomProviderIdRoute: WaitingRoomProviderIdRoute,
  LegalIndexRoute: LegalIndexRoute,
  AppointmentsConfirmTokenRoute: AppointmentsConfirmTokenRoute,
  DisplayFacilityIdCheckinRoute: DisplayFacilityIdCheckinRoute,
  WidgetBookProviderIdRoute: WidgetBookProviderIdRoute,
  DisplayFacilityIdIndexRoute: DisplayFacilityIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
